import React, { useEffect, useMemo, useState } from "react";

const API_BASE = "https://panel.haymestasarim.com/api";
const LANG_INDEX = { tr: 0, en: 1, de: 2 };

const COPY = {
  eyebrow: [
    "KURUMSAL FİNANS MERKEZİ",
    "CORPORATE FINANCE CENTER",
    "PROFESSIONELLES FINANZZENTRUM",
  ],
  title: [
    "Finans, Kasa & Kurumsal Raporlama",
    "Finance, Cash & Corporate Reporting",
    "Finanzen, Kasse & Berichte",
  ],
  subtitle: [
    "Tüm gelir, gider, maaş ve entegrasyon hareketlerinizi yönetin; firma bilgilerinizle kurumsal raporlar hazırlayın.",
    "Manage income, expenses, payroll and integrated transactions; create corporate reports with your company details.",
    "Verwalten Sie Einnahmen, Ausgaben, Löhne und integrierte Buchungen mit professionellen Berichten.",
  ],
  overview: ["Finans Özeti", "Finance Overview", "Finanzübersicht"],
  movements: ["Kasa Hareketleri", "Cash Transactions", "Kassenbewegungen"],
  payroll: ["Personel & Maaş", "Staff & Payroll", "Personal & Lohn"],
  reports: [
    "Kurumsal Raporlar",
    "Corporate Reports",
    "Unternehmensberichte",
  ],
  company: ["Firma Bilgileri", "Company Information", "Firmendaten"],
  training: ["Eğitim Merkezi", "Training Center", "Schulungszentrum"],
  newRecord: ["Yeni İşlem", "New Transaction", "Neue Buchung"],
  refresh: ["Yenile", "Refresh", "Aktualisieren"],
  csv: ["CSV İndir", "Download CSV", "CSV herunterladen"],
  print: [
    "Kurumsal Rapor Al",
    "Print Corporate Report",
    "Unternehmensbericht",
  ],
  income: ["Toplam Gelir", "Total Income", "Gesamteinnahmen"],
  expense: ["Toplam Gider", "Total Expense", "Gesamtausgaben"],
  net: ["Net Durum", "Net Position", "Nettoergebnis"],
  payrollTotal: [
    "Maaş Ödemeleri",
    "Payroll Payments",
    "Lohnzahlungen",
  ],
  quick: ["Hızlı İşlemler", "Quick Transactions", "Schnellbuchungen"],
  expenseBreakdown: [
    "Gider Dağılımı",
    "Expense Breakdown",
    "Ausgabenverteilung",
  ],
  latest: [
    "Son Finans Hareketleri",
    "Latest Transactions",
    "Letzte Buchungen",
  ],
  filters: ["Rapor Filtreleri", "Report Filters", "Berichtsfilter"],
  search: ["Ara", "Search", "Suchen"],
  type: ["İşlem Türü", "Transaction Type", "Buchungsart"],
  source: ["Kaynak / Grup", "Source / Group", "Quelle / Gruppe"],
  category: ["Kategori", "Category", "Kategorie"],
  payment: ["Ödeme Yöntemi", "Payment Method", "Zahlungsart"],
  staff: ["Personel", "Staff", "Personal"],
  branch: ["Şube", "Branch", "Filiale"],
  currency: ["Para Birimi", "Currency", "Währung"],
  start: ["Başlangıç", "Start", "Start"],
  end: ["Bitiş", "End", "Ende"],
  all: ["Tümü", "All", "Alle"],
  clear: ["Temizle", "Clear", "Löschen"],
  today: ["Bugün", "Today", "Heute"],
  week: ["Bu Hafta", "This Week", "Diese Woche"],
  month: ["Bu Ay", "This Month", "Dieser Monat"],
  year: ["Bu Yıl", "This Year", "Dieses Jahr"],
  allTime: ["Tüm Zamanlar", "All Time", "Gesamt"],
  date: ["Tarih", "Date", "Datum"],
  recordTitle: [
    "İşlem Başlığı",
    "Transaction Title",
    "Buchungstitel",
  ],
  related: ["İlgili Kişi / Kurum", "Related Party", "Gegenpartei"],
  amount: ["Tutar", "Amount", "Betrag"],
  actions: ["İşlem", "Action", "Aktion"],
  edit: ["Düzenle", "Edit", "Bearbeiten"],
  delete: ["Sil", "Delete", "Löschen"],
  save: ["Kaydet", "Save", "Speichern"],
  update: ["Güncelle", "Update", "Aktualisieren"],
  cancel: ["Vazgeç", "Cancel", "Abbrechen"],
  noData: [
    "Seçili kriterlerde kayıt bulunamadı.",
    "No records for selected criteria.",
    "Keine passenden Buchungen.",
  ],
  loading: [
    "Finans verileri hazırlanıyor...",
    "Preparing finance data...",
    "Finanzdaten werden vorbereitet...",
  ],
  retry: ["Tekrar Dene", "Try Again", "Erneut versuchen"],
  staffCards: ["Personel Kartları", "Staff Records", "Personalkarten"],
  addStaff: [
    "Personel Ekle / Düzenle",
    "Add / Edit Staff",
    "Personal hinzufügen",
  ],
  salaryPayment: [
    "Maaş Ödemesi Yap",
    "Make Salary Payment",
    "Lohnzahlung",
  ],
  salaryHistory: [
    "Maaş Ödeme Geçmişi",
    "Payroll History",
    "Lohnhistorie",
  ],
  reportSummary: [
    "Rapor Özeti",
    "Report Summary",
    "Berichtsübersicht",
  ],
  payrollReport: [
    "Personel Bazlı Maaş Raporu",
    "Payroll by Staff",
    "Lohnbericht nach Personal",
  ],
  categoryReport: [
    "Kategori Bazlı Rapor",
    "Report by Category",
    "Bericht nach Kategorie",
  ],
  transactionReport: [
    "Ayrıntılı İşlem Dökümü",
    "Detailed Transactions",
    "Buchungsdetails",
  ],
  companyForm: [
    "Kurumsal Rapor Bilgileri",
    "Corporate Report Information",
    "Unternehmensdaten",
  ],
  companyPreview: [
    "Rapor Başlığı Önizlemesi",
    "Report Header Preview",
    "Vorschau Berichtskopf",
  ],
  saveDraft: ["Taslağı Kaydet", "Save Draft", "Entwurf speichern"],
  frontendDraft: [
    "Backend bağlanana kadar bu bilgiler yalnızca bu tarayıcıda taslak olarak saklanır.",
    "Until the backend is connected, this data is saved only in this browser.",
    "Bis zur Backend-Anbindung werden diese Daten nur im Browser gespeichert.",
  ],
  trainingIntro: [
    "Kasa ve finans modülünü doğru kullanmak için aşağıdaki eğitimleri sırayla tamamlayabilirsiniz.",
    "Complete the lessons below to use the finance module correctly.",
    "Folgen Sie den Schulungen zur korrekten Nutzung.",
  ],
};

const PAYMENT_LABELS = {
  cash: ["Nakit", "Cash", "Bar"],
  card: ["Kart", "Card", "Karte"],
  bank: ["Banka / Havale", "Bank / Transfer", "Bank / Überweisung"],
  other: ["Diğer", "Other", "Andere"],
};

const MODULE_LABELS = {
  manual: ["Manuel Kayıt", "Manual Entry", "Manuelle Buchung"],
  service: [
    "Hizmet & Satış",
    "Service & Sales",
    "Dienstleistung & Verkauf",
  ],
  membership: [
    "Aidat & Üyelik",
    "Dues & Membership",
    "Beitrag & Mitgliedschaft",
  ],
  donation: [
    "Bağış & Sponsorluk",
    "Donation & Sponsorship",
    "Spende & Sponsoring",
  ],
  event: [
    "Etkinlik & Organizasyon",
    "Event & Organization",
    "Veranstaltung",
  ],
  professional: [
    "Mesleki Hizmet",
    "Professional Service",
    "Dienstleistung",
  ],
  payroll: ["Maaş & Personel", "Payroll & Staff", "Lohn & Personal"],
  operating: [
    "İşletme Gideri",
    "Operating Expense",
    "Betriebsausgabe",
  ],
  tax: [
    "Vergi & Resmî Ödeme",
    "Tax & Official Payment",
    "Steuer & Abgabe",
  ],
  supplier: ["Tedarikçi", "Supplier", "Lieferant"],
  beauty: ["Beauty", "Beauty", "Beauty"],
  menu: ["QR Menü", "QR Menu", "QR-Menü"],
  appointment: ["Randevu", "Appointment", "Termin"],
  stock: ["Stok", "Stock", "Lager"],
  hotel: ["Otel", "Hotel", "Hotel"],
  integration: ["Entegrasyon", "Integration", "Integration"],
  phone_order: [
    "Telefon Siparişi",
    "Phone Order",
    "Telefonbestellung",
  ],
  pos: ["POS", "POS", "POS"],
  other: ["Diğer", "Other", "Andere"],
};

const CATEGORIES = {
  income: [
    "Hizmet Geliri",
    "Ürün Satışı",
    "Paket / Üyelik Satışı",
    "Aidat Geliri",
    "Bağış Geliri",
    "Sponsorluk Geliri",
    "Etkinlik / Organizasyon Geliri",
    "Randevu Tahsilatı",
    "QR Menü / Sipariş Geliri",
    "Otel / Konaklama Geliri",
    "Eğitim / Danışmanlık Geliri",
    "Kira Geliri",
    "Cari Tahsilat",
    "Komisyon Geliri",
    "Diğer Gelir",
  ],
  expense: [
    "Maaş ve Ücretler",
    "Personel Avansı",
    "SGK / Sigorta",
    "Yemek ve Yan Haklar",
    "İşyeri Kirası",
    "Elektrik / Su / Doğalgaz",
    "İnternet / Telefon",
    "Vergi / Harç",
    "Muhasebe / Mali Müşavir",
    "Stok / Malzeme Alımı",
    "Tedarikçi Ödemesi",
    "Reklam / Pazarlama",
    "Yazılım / Abonelik",
    "Ulaşım / Yakıt",
    "Banka / POS Komisyonu",
    "Personel Primi / Komisyonu",
    "Bakım / Onarım",
    "Temizlik / Housekeeping",
    "Etkinlik / Organizasyon Gideri",
    "Yardım / Burs Ödemesi",
    "Otel İşletme Gideri",
    "Ofis Gideri",
    "Diğer Gider",
  ],
};

const QUICK_TEMPLATES = [
  [
    "GL",
    "Gelir Ekle",
    "Hizmet, satış veya tahsilat",
    "service",
    "income",
    "Gelir Kaydı",
    "Hizmet Geliri",
    "blue",
  ],
  [
    "GD",
    "Gider Ekle",
    "Genel işletme gideri",
    "operating",
    "expense",
    "Gider Kaydı",
    "Diğer Gider",
    "cyan",
  ],
  [
    "MŞ",
    "Maaş Ödemesi",
    "Personel maaş ve ücretleri",
    "payroll",
    "expense",
    "Maaş Ödemesi",
    "Maaş ve Ücretler",
    "violet",
  ],
  [
    "KF",
    "Kira / Fatura",
    "Kira, elektrik, su veya internet",
    "operating",
    "expense",
    "Sabit İşletme Gideri",
    "İşyeri Kirası",
    "orange",
  ],
  [
    "VG",
    "Vergi Ödemesi",
    "Vergi, harç ve resmî ödeme",
    "tax",
    "expense",
    "Vergi Ödemesi",
    "Vergi / Harç",
    "red",
  ],
  [
    "TD",
    "Tedarikçi",
    "Malzeme veya cari ödeme",
    "supplier",
    "expense",
    "Tedarikçi Ödemesi",
    "Tedarikçi Ödemesi",
    "slate",
  ],
  [
    "AB",
    "Aidat / Bağış",
    "Üye aidatı, bağış veya sponsor",
    "membership",
    "income",
    "Aidat / Bağış Tahsilatı",
    "Aidat Geliri",
    "rose",
  ],
  [
    "DĞ",
    "Diğer İşlem",
    "Her sektöre uygun özel kayıt",
    "manual",
    "income",
    "Diğer İşlem",
    "Diğer Gelir",
    "amber",
  ],
];

const DEFAULT_COMPANY = {
  logo: "",
  legal_name: "",
  display_name: "",
  tax_office: "",
  tax_number: "",
  registry_number: "",
  address: "",
  phone: "",
  email: "",
  website: "",
  iban: "",
  authorized_person: "",
  default_currency: "TRY",
  report_note: "Bu rapor sistem üzerinden oluşturulmuştur.",
};

const EMPTY_FORM = {
  module_type: "manual",
  transaction_type: "income",
  title: "",
  category: "",
  quantity: "1",
  unit_price: "",
  total_amount: "",
  currency: "TRY",

    payment_method: "cash",
  customer_id: "",
  cari_customer_id: "",
  beauty_customer_id: "",
  customer_name: "",
  staff_name: "",

  note: "",
  transaction_date: "",
};

const EMPTY_EMPLOYEE = {
  id: "",
  name: "",
  role: "",
  branch: "",
  base_salary: "",
  currency: "TRY",
  iban: "",
  phone: "",
  active: true,
};

const EMPTY_PAYROLL = {
  employee_id: "",
  period: "",
  gross: "",
  bonus: "",
  deduction: "",
  currency: "TRY",
  payment_method: "bank",
  payment_date: "",
  note: "",
};

const TRAINING_ITEMS = [
  {
    title: "1. Firma bilgilerini hazırlama",
    text:
      "Firma Bilgileri sekmesinden logo, resmî unvan, vergi bilgileri, adres, iletişim ve yetkili alanlarını doldurun. Bu bilgiler kurumsal raporun üst kısmında görünür.",
    steps: [
      "Firma Bilgileri sekmesini açın.",
      "Zorunlu alanları doldurun.",
      "Logo ekleyin.",
      "Taslağı kaydedin.",
      "Rapor önizlemesini kontrol edin.",
    ],
  },
  {
    title: "2. Gelir kaydı oluşturma",
    text:
      "Hizmet satışı, ürün satışı, aidat, bağış, sponsorluk, randevu veya diğer tahsilatlar gelir olarak kaydedilir.",
    steps: [
      "Yeni İşlem veya Gelir Ekle seçeneğine basın.",
      "Gelir türünü seçin.",
      "Başlık ve kategori girin.",
      "Tutar, para birimi ve ödeme yöntemini seçin.",
      "Kaydedin.",
    ],
  },
  {
    title: "3. Gider kaydı oluşturma",
    text:
      "Kira, fatura, vergi, tedarikçi, bakım, reklam ve diğer işletme harcamaları gider olarak kaydedilir.",
    steps: [
      "Gider Ekle seçeneğine basın.",
      "Doğru gider kategorisini seçin.",
      "Ödeme yapılan kişi veya kurumu yazın.",
      "Belge açıklamasını not alanına ekleyin.",
      "Kaydedin.",
    ],
  },
  {
    title: "4. Personel ve maaş işlemleri",
    text:
      "Önce personel kartını oluşturun. Ardından dönem, brüt ücret, prim ve kesinti bilgilerini girerek maaş ödemesini kasaya kaydedin.",
    steps: [
      "Personel & Maaş sekmesine girin.",
      "Personel kartını ekleyin.",
      "Maaş dönemi seçin.",
      "Brüt, prim ve kesinti alanlarını doldurun.",
      "Ödemeyi kaydedin.",
    ],
  },
  {
    title: "5. Entegrasyonlardan gelen hareketler",
    text:
      "Stok, cari, otel, Beauty, QR menü, telefon siparişi ve randevu modüllerinden gelen kayıtlar kaynak bilgisiyle birlikte kasa hareketlerinde görünür.",
    steps: [
      "Kasa Hareketleri sekmesini açın.",
      "Kaynak filtresini seçin.",
      "İlgili modülü filtreleyin.",
      "İşlem tutarını ve ödeme yöntemini kontrol edin.",
    ],
  },
  {
    title: "6. Kurumsal rapor hazırlama",
    text:
      "Rapor dönemini, para birimini, kaynağı, kategoriyi ve personeli seçerek gelir–gider, maaş ve ayrıntılı işlem dökümünü oluşturun.",
    steps: [
      "Kurumsal Raporlar sekmesini açın.",
      "Tarih ve para birimini seçin.",
      "Gerekirse personel veya kategori filtresi uygulayın.",
      "Kurumsal Rapor Al düğmesine basın.",
      "Yazdırın veya PDF olarak kaydedin.",
    ],
  },
  {
    title: "7. Yanlış kaydı düzeltme",
    text:
      "Yanlış girilen kayıt düzenlenebilir veya yetkiniz varsa silinebilir. Backend aşamasında silme yerine iptal/ters kayıt yapısı eklenecektir.",
    steps: [
      "Kasa Hareketleri sekmesine girin.",
      "Kaydı bulun.",
      "Düzenle seçeneğiyle bilgileri düzeltin.",
      "Gerekirse silme işlemini onaylayın.",
    ],
  },
];

function getLang() {
  const raw =
    localStorage.getItem("panel_dili") ||
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";

  const lang = String(raw).slice(0, 2).toLowerCase();

  return LANG_INDEX[lang] !== undefined ? lang : "tr";
}

function authHeaders() {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };
}

function localDate(value = new Date()) {
  const date = new Date(value);

  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
}

function currentMonth() {
  return localDate().slice(0, 7);
}

function numberValue(value) {
  const result = Number(value || 0);

  return Number.isFinite(result) ? result : 0;
}

function money(value, currency = "TRY", lang = "tr") {
  const locale =
    lang === "de" ? "de-CH" : lang === "en" ? "en-GB" : "tr-TR";

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency || "TRY",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numberValue(value));
  } catch (_) {
    return `${numberValue(value).toLocaleString(locale)} ${
      currency || ""
    }`;
  }
}

function parseStored(key, fallback) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || "null");

    return value || fallback;
  } catch (_) {
    return fallback;
  }
}

function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function normalizeCustomerKey(customer = {}) {
  const phone = String(customer.phone || "").replace(/\D/g, "");

  if (phone) return `phone:${phone}`;

  const name = String(customer.full_name || customer.name || "")
    .trim()
    .toLocaleLowerCase("tr-TR");

  return name
    ? `name:${name}`
    : `row:${customer.id || Math.random()}`;
}

function packageRemainingDebt(pkg = {}) {
  const explicitRemaining =
    pkg.remaining_debt ??
    pkg.debt_amount ??
    pkg.kalan_borc ??
    pkg.balance_amount;

  if (
    explicitRemaining !== undefined &&
    explicitRemaining !== null
  ) {
    return Math.max(numberValue(explicitRemaining), 0);
  }

  return Math.max(
    numberValue(pkg.sale_price || pkg.total_amount) -
      numberValue(pkg.paid_amount || pkg.total_paid),
    0
  );
}

export default function KasaPanel() {


  const [lang, setLang] = useState(getLang());
  const languageIndex = LANG_INDEX[lang];

  const tx = (key) =>
    COPY[key]?.[languageIndex] || COPY[key]?.[0] || key;

  const label = (map, key) =>
    map[key]?.[languageIndex] || map[key]?.[0] || key || "-";

  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [records, setRecords] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [beautyPackages, setBeautyPackages] = useState([]);
  const [customerSearch, setCustomerSearch] = useState("");
  const [beautyCategories, setBeautyCategories] = useState([]);

  const [showTransactionForm, setShowTransactionForm] =
    useState(false);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    ...EMPTY_FORM,
    transaction_date: localDate(),
  });

  const [company, setCompany] = useState(() => ({
    ...DEFAULT_COMPANY,
    ...parseStored("cash_company_draft", {}),
  }));

  const [employees, setEmployees] = useState(() =>
    parseStored("cash_employee_draft", [])
  );

  const [employeeForm, setEmployeeForm] = useState({
    ...EMPTY_EMPLOYEE,
  });

  const [editingEmployeeId, setEditingEmployeeId] = useState(null);

  const [payrollForm, setPayrollForm] = useState({
    ...EMPTY_PAYROLL,
    period: currentMonth(),
    payment_date: localDate(),
  });

  const [openTraining, setOpenTraining] = useState(0);
  const [notice, setNotice] = useState("");
  const [mobileFilters, setMobileFilters] = useState(false);

  const [filters, setFilters] = useState(() => {
    const now = new Date();

    const preferredCurrency =
      localStorage.getItem("cash_report_currency") ||
      parseStored("cash_company_draft", {})?.default_currency ||
      "TRY";

    return {
      q: "",
      type: "all",
      module: "all",
      category: "all",
      payment: "all",
      staff: "all",
      branch: "all",
      currency: preferredCurrency,
      period: "month",
      start: localDate(
        new Date(now.getFullYear(), now.getMonth(), 1)
      ),
      end: localDate(now),
    };
  });

  async function request(url, options) {
    const response = await fetch(url, options);
    const json = await response.json().catch(() => ({}));

    if (!response.ok || json.ok === false) {
      throw new Error(json.message || `HTTP ${response.status}`);
    }

    return json;
  }

  async function loadRecords() {
    setLoading(true);
    setError("");

    try {
      const json = await request(`${API_BASE}/cash`, {
        headers: authHeaders(),
      });

      setRecords(Array.isArray(json.data) ? json.data : []);
    } catch (err) {
      console.error("Kasa kayıtları alınamadı:", err);
      setError(err.message || "Kasa kayıtları alınamadı");
    } finally {
      setLoading(false);
    }
  }

   async function loadCustomers() {


    const [beautyResult, cariResult, packageResult] =
      await Promise.allSettled([
        request(`${API_BASE}/beaty/pro/customers`, {
          headers: authHeaders(),
        }),
        request(`${API_BASE}/cari/customers?limit=1000`, {
          headers: authHeaders(),
        }),
        request(
          `${API_BASE}/beaty/pro/customer-packages`,
          {
            headers: authHeaders(),
          }
        ),
      ]);

    const beautyRows =
      beautyResult.status === "fulfilled" &&
      Array.isArray(beautyResult.value.data)
        ? beautyResult.value.data
        : [];

    const cariRows =
      cariResult.status === "fulfilled" &&
      Array.isArray(cariResult.value.data)
        ? cariResult.value.data
        : [];

    setBeautyPackages(
      packageResult.status === "fulfilled" &&
        Array.isArray(packageResult.value.data)
        ? packageResult.value.data
        : []
    );

    const merged = new Map();

    cariRows.forEach((customer) => {
      const key = normalizeCustomerKey(customer);

      merged.set(key, {
        ...customer,
        key,
        display_name:
          customer.full_name || customer.name || "",
        cash_id: customer.id,
        beauty_id:
          customer.beaty_customer_id ||
          customer.beauty_customer_id ||
          null,
      });
    });

    beautyRows.forEach((customer) => {
      const key = normalizeCustomerKey(customer);
      const old = merged.get(key);

      merged.set(key, {
        ...(old || customer),
        key,
        display_name:
          old?.display_name ||
          customer.full_name ||
          customer.name ||
          "",
        phone: old?.phone || customer.phone || "",
        email: old?.email || customer.email || "",
        cash_id: old?.cash_id || null,
        beauty_id: old?.beauty_id || customer.id,
      });
    });

    setCustomers(
      Array.from(merged.values()).sort((a, b) =>
        String(a.display_name || "").localeCompare(
          String(b.display_name || ""),
          "tr"
        )
      )
    );
  }

  async function loadBeautyCategories() {
    try {
      const json = await request(
        `${API_BASE}/beaty/categories`,
        {
          headers: authHeaders(),
        }
      );

      setBeautyCategories(
        Array.isArray(json.data) ? json.data : []
      );
    } catch (_) {
      setBeautyCategories([]);
    }
  }

  useEffect(() => {
    loadRecords();
    loadCustomers();
    loadBeautyCategories();

    const syncLanguage = () => setLang(getLang());

    window.addEventListener("app_lang_change", syncLanguage);
    window.addEventListener("storage", syncLanguage);

    return () => {
      window.removeEventListener(
        "app_lang_change",
        syncLanguage
      );
      window.removeEventListener("storage", syncLanguage);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "cash_report_currency",
      filters.currency
    );
  }, [filters.currency]);

  useEffect(() => {
    if (!notice) return undefined;

    const timer = window.setTimeout(() => setNotice(""), 2800);

    return () => window.clearTimeout(timer);
  }, [notice]);

  const currencies = useMemo(() => {
    const values = new Set(["TRY", "CHF", "EUR", "USD"]);

    records.forEach((record) => {
      if (record.currency) {
        values.add(String(record.currency).toUpperCase());
      }
    });

    employees.forEach((employee) => {
      if (employee.currency) {
        values.add(String(employee.currency).toUpperCase());
      }
    });

    return Array.from(values);
  }, [records, employees]);

  const modules = useMemo(() => {
    const values = new Set(Object.keys(MODULE_LABELS));

    records.forEach((record) => {
      if (record.module_type) {
        values.add(record.module_type);
      }
    });

    return Array.from(values);
  }, [records]);

  const categories = useMemo(() => {
    const values = new Set([
      ...CATEGORIES.income,
      ...CATEGORIES.expense,
    ]);

    records.forEach((record) => {
      if (record.category) {
        values.add(record.category);
      }
    });

    return Array.from(values).sort((a, b) =>
      a.localeCompare(b, "tr")
    );
  }, [records]);

  const staffNames = useMemo(() => {
    const values = new Set();

    employees.forEach((employee) => {
      if (employee.name) {
        values.add(employee.name);
      }
    });

    records.forEach((record) => {
      if (record.staff_name) {
        values.add(record.staff_name);
      }
    });

    return Array.from(values).sort((a, b) =>
      a.localeCompare(b, "tr")
    );
  }, [employees, records]);

  const branches = useMemo(() => {
    const values = new Set();

    employees.forEach((employee) => {
      if (employee.branch) {
        values.add(employee.branch);
      }
    });

    records.forEach((record) => {
      if (record.sube_id) {
        values.add(String(record.sube_id));
      }
    });

    return Array.from(values);
  }, [employees, records]);

  const categoryOptions = useMemo(() => {
    const base =
      CATEGORIES[form.transaction_type] || [];

    const beauty =
      form.module_type === "beauty"
        ? beautyCategories
            .map(
              (item) =>
                item.name ||
                item.title ||
                item.category_name
            )
            .filter(Boolean)
        : [];

    const old = records
      .filter(
        (record) =>
          record.transaction_type ===
          form.transaction_type
      )
      .map((record) => record.category)
      .filter(Boolean);

    return Array.from(
      new Set([...base, ...beauty, ...old])
    );
  }, [
    form.transaction_type,
    form.module_type,
    beautyCategories,
    records,
  ]);

  const filteredRecords = useMemo(() => {
    return records.filter((record) => {
      const query = filters.q
        .trim()
        .toLocaleLowerCase("tr-TR");

      const searchText = [
        record.title,
        record.category,
        record.customer_name,
        record.staff_name,
        record.note,
        record.module_type,
        record.payment_method,
      ]
        .join(" ")
        .toLocaleLowerCase("tr-TR");

      const recordDate = String(
        record.transaction_date || ""
      ).slice(0, 10);

      const recordCurrency = String(
        record.currency || "TRY"
      ).toUpperCase();

      if (query && !searchText.includes(query)) {
        return false;
      }

      if (
        filters.type !== "all" &&
        record.transaction_type !== filters.type
      ) {
        return false;
      }

      if (
        filters.module !== "all" &&
        record.module_type !== filters.module
      ) {
        return false;
      }

      if (
        filters.category !== "all" &&
        record.category !== filters.category
      ) {
        return false;
      }

      if (
        filters.payment !== "all" &&
        record.payment_method !== filters.payment
      ) {
        return false;
      }

      if (
        filters.staff !== "all" &&
        record.staff_name !== filters.staff
      ) {
        return false;
      }

      if (filters.branch !== "all") {
        const branchMatch =
          String(record.sube_id || "") ===
            filters.branch ||
          employees.some(
            (employee) =>
              employee.name === record.staff_name &&
              employee.branch === filters.branch
          );

        if (!branchMatch) {
          return false;
        }
      }

      if (recordCurrency !== filters.currency) {
        return false;
      }

      if (
        filters.start &&
        recordDate < filters.start
      ) {
        return false;
      }

      if (filters.end && recordDate > filters.end) {
        return false;
      }

      return true;
    });
  }, [records, filters, employees]);

  const totals = useMemo(() => {
    return filteredRecords.reduce(
      (result, record) => {
        const amount = numberValue(
          record.total_amount
        );

        if (
          record.transaction_type === "expense"
        ) {
          result.expense += amount;
        } else {
          result.income += amount;
        }

        const category = String(
          record.category || ""
        ).toLocaleLowerCase("tr-TR");

        const isPayroll =
          record.module_type === "payroll" ||
          /maaş|ücret|personel|avans|sgk|sigorta|salary|lohn/.test(
            category
          );

        if (
          record.transaction_type === "expense" &&
          isPayroll
        ) {
          result.payroll += amount;
        }

        return result;
      },
      {
        income: 0,
        expense: 0,
        payroll: 0,
      }
    );
  }, [filteredRecords]);

  const payrollRecords = useMemo(() => {
    return filteredRecords.filter((record) => {
      const category = String(
        record.category || ""
      ).toLocaleLowerCase("tr-TR");

      return (
        record.module_type === "payroll" ||
        /maaş|ücret|personel|avans|prim|sgk|sigorta|salary|lohn/.test(
          category
        )
      );
    });
  }, [filteredRecords]);

  const payrollByStaff = useMemo(() => {
    const grouped = new Map();

    payrollRecords.forEach((record) => {
      const name =
        record.staff_name ||
        "Personel belirtilmemiş";

      const current = grouped.get(name) || {
        name,
        total: 0,
        count: 0,
        lastDate: "",
      };

      current.total += numberValue(
        record.total_amount
      );

      current.count += 1;

      const date = String(
        record.transaction_date || ""
      ).slice(0, 10);

      if (date > current.lastDate) {
        current.lastDate = date;
      }

      grouped.set(name, current);
    });

    return Array.from(grouped.values()).sort(
      (a, b) => b.total - a.total
    );
  }, [payrollRecords]);

  const categorySummary = useMemo(() => {
    const grouped = new Map();

    filteredRecords.forEach((record) => {
      const name =
        record.category ||
        MODULE_LABELS[
          record.module_type || "manual"
        ]?.[languageIndex] ||
        MODULE_LABELS[
          record.module_type || "manual"
        ]?.[0] ||
        record.module_type ||
        "Manuel Kayıt";

      const key = `${record.transaction_type}::${name}`;

      const current = grouped.get(key) || {
        name,
        type: record.transaction_type,
        total: 0,
        count: 0,
      };

      current.total += numberValue(
        record.total_amount
      );

      current.count += 1;

      grouped.set(key, current);
    });

    return Array.from(grouped.values()).sort(
      (a, b) => b.total - a.total
    );
  }, [filteredRecords, languageIndex]);

  const expenseGroups = useMemo(
    () =>
      categorySummary
        .filter(
          (item) => item.type === "expense"
        )
        .slice(0, 7),
    [categorySummary]
  );

  const customerSearchResults = useMemo(() => {
    const query = String(customerSearch || "")
      .trim()
      .toLocaleLowerCase("tr-TR");

    if (query.length < 2) return [];

    return customers
      .filter((customer) =>
        [
          customer.display_name,
          customer.full_name,
          customer.name,
          customer.phone,
          customer.email,
        ]
          .filter(Boolean)
          .join(" ")
          .toLocaleLowerCase("tr-TR")
          .includes(query)
      )
      .slice(0, 8);
  }, [customers, customerSearch]);

  const effectiveAmount =
    form.total_amount !== ""

      ? numberValue(form.total_amount)
      : numberValue(form.quantity || 1) *
        numberValue(form.unit_price);

  const payrollNet =
    numberValue(payrollForm.gross) +
    numberValue(payrollForm.bonus) -
    numberValue(payrollForm.deduction);

  const net = totals.income - totals.expense;

  function setPeriod(period) {
    const now = new Date();

    let start = "";
    let end = localDate(now);

    if (period === "today") {
      start = end;
    }

    if (period === "week") {
      const monday = new Date(now);

      monday.setDate(
        now.getDate() - (now.getDay() || 7) + 1
      );

      start = localDate(monday);
    }

    if (period === "month") {
      start = localDate(
        new Date(
          now.getFullYear(),
          now.getMonth(),
          1
        )
      );
    }

    if (period === "year") {
      start = localDate(
        new Date(now.getFullYear(), 0, 1)
      );
    }

    if (period === "all") {
      end = "";
    }

    setFilters((current) => ({
      ...current,
      period,
      start,
      end,
    }));
  }

  function clearFilters() {
    const now = new Date();

    setFilters((current) => ({
      ...current,
      q: "",
      type: "all",
      module: "all",
      category: "all",
      payment: "all",
      staff: "all",
      branch: "all",
      period: "month",
      start: localDate(
        new Date(
          now.getFullYear(),
          now.getMonth(),
          1
        )
      ),
      end: localDate(now),
    }));
  }

  function resetTransactionForm() {
    setEditingId(null);
    setCustomerSearch("");

    setForm({
      ...EMPTY_FORM,
      currency: filters.currency,
      transaction_date: localDate(),
    });
  }

  function openNewTransaction(template = null) {
    setActiveTab("movements");
    resetTransactionForm();

    if (template) {
      setForm({
        ...EMPTY_FORM,
        module_type: template[3],
        transaction_type: template[4],
        title: template[5],
        category: template[6],
        currency: filters.currency,
        transaction_date: localDate(),
      });
    }

    setShowTransactionForm(true);

    window.setTimeout(() => {
      document
        .getElementById(
          "finance-transaction-form"
        )
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 60);
  }

  function selectCustomer(customer) {
    const displayName =
      customer?.display_name ||
      customer?.full_name ||
      customer?.name ||
      "";

    setForm((current) => ({
      ...current,
      customer_name: displayName,
      customer_id: customer?.cash_id || "",
      cari_customer_id: customer?.cash_id || "",
      beauty_customer_id: customer?.beauty_id || "",
    }));

    setCustomerSearch(
      `${displayName}${
        customer?.phone ? ` - ${customer.phone}` : ""
      }`
    );
  }

  function clearSelectedCustomer() {
    setCustomerSearch("");

    setForm((current) => ({
      ...current,
      customer_id: "",
      cari_customer_id: "",
      beauty_customer_id: "",
      customer_name: "",
    }));
  }


  async function saveTransaction() {
    if (!String(form.title || "").trim()) {
      window.alert("İşlem başlığı zorunludur.");
      return;
    }

    if (effectiveAmount <= 0) {
      window.alert("Tutar sıfırdan büyük olmalıdır.");
      return;
    }

    if (
      customerSearch.trim() &&
      !form.cari_customer_id &&
      !form.beauty_customer_id &&
      !editingId
    ) {
      window.alert(
        "Arama sonucundan gerçek bir cari seçmelisiniz."
      );
      return;
    }

    const beautyPaymentCustomerId =
      form.beauty_customer_id ||
      (form.module_type === "beauty"
        ? form.customer_id
        : "");

    const shouldCreateBeautyPayment =
      !editingId &&
      form.transaction_type === "income" &&
      Boolean(beautyPaymentCustomerId);

    if (
      form.module_type === "beauty" &&
      !editingId &&
      !beautyPaymentCustomerId
    ) {
      window.alert(
        "Beauty tahsilatı için listeden müşteri seçmelisiniz."
      );
      return;
    }

    const wasEditing = Boolean(editingId);

    setSaving(true);

    try {
      if (shouldCreateBeautyPayment) {
        const customerPackage = beautyPackages
          .filter(
            (pkg) =>
              String(pkg.customer_id) ===
                String(beautyPaymentCustomerId) &&
              packageRemainingDebt(pkg) > 0
          )
          .sort((a, b) =>
            String(
              a.sale_date || a.created_at || ""
            ).localeCompare(
              String(b.sale_date || b.created_at || "")
            )
          )[0];

        await request(
          `${API_BASE}/beaty/pro/payments`,
          {
            method: "POST",
            headers: authHeaders(),
            body: JSON.stringify({
              customer_id: beautyPaymentCustomerId,
              customer_package_id:
                customerPackage?.id || null,
              amount: effectiveAmount,
              currency: form.currency,
              payment_type: form.payment_method,
              payment_method: form.payment_method,
              note: form.note || form.title,
              payment_date: form.transaction_date,
            }),
          }
        );

        try {
          await request(
            `${API_BASE}/cari/import-beaty`,
            {
              method: "POST",
              headers: authHeaders(),
            }
          );
        } catch (syncError) {
          console.warn(
            "Cari eşitleme yapılamadı:",
            syncError
          );
        }
      } else {
        const cashForm = { ...form };

        const cariCustomerId =
          cashForm.cari_customer_id ||
          cashForm.customer_id ||
          null;

        delete cashForm.cari_customer_id;
        delete cashForm.beauty_customer_id;

        await request(
          editingId
            ? `${API_BASE}/cash/${editingId}`
            : `${API_BASE}/cash`,
          {
            method: editingId ? "PUT" : "POST",
            headers: authHeaders(),
            body: JSON.stringify({
              ...cashForm,
              customer_id: cariCustomerId,
              quantity: numberValue(
                form.quantity || 1
              ),
              unit_price: numberValue(
                form.unit_price
              ),
              total_amount: effectiveAmount,
            }),
          }
        );
      }

      resetTransactionForm();
      setShowTransactionForm(false);

      await Promise.all([
        loadRecords(),
        loadCustomers(),
      ]);

      setNotice(
        wasEditing
          ? "İşlem güncellendi."
          : "İşlem kaydedildi."
      );
    } catch (err) {
      window.alert(
        err.message || "Sunucuya bağlanılamadı."
      );
    } finally {
      setSaving(false);
    }
  }

    function editTransaction(record) {
    setEditingId(record.id);

    const linkedCustomer = customers.find(
      (customer) =>
        String(customer.cash_id || "") ===
          String(record.customer_id || "") ||
        String(customer.beauty_id || "") ===
          String(record.customer_id || "") ||
        (record.customer_name &&
          String(customer.display_name || "")
            .trim()
            .toLocaleLowerCase("tr-TR") ===
            String(record.customer_name)
              .trim()
              .toLocaleLowerCase("tr-TR"))
    );

    setCustomerSearch(
      linkedCustomer
        ? `${linkedCustomer.display_name || ""}${
            linkedCustomer.phone
              ? ` - ${linkedCustomer.phone}`
              : ""
          }`
        : record.customer_name || ""
    );

    setForm({
      module_type: record.module_type || "manual",
      transaction_type:
        record.transaction_type || "income",
      title: record.title || "",
      category: record.category || "",
      quantity: String(record.quantity || 1),
      unit_price: String(record.unit_price || ""),
      total_amount: String(record.total_amount || ""),
      currency: record.currency || "TRY",
      payment_method:
        record.payment_method || "cash",
      customer_id: record.customer_id || "",
      cari_customer_id:
        linkedCustomer?.cash_id ||
        record.customer_id ||
        "",
      beauty_customer_id:
        linkedCustomer?.beauty_id || "",
      customer_name: record.customer_name || "",
      staff_name: record.staff_name || "",
      note: record.note || "",
      transaction_date:
        String(
          record.transaction_date || ""
        ).slice(0, 10) || localDate(),
    });

    setShowTransactionForm(true);
    setActiveTab("movements");

    window.setTimeout(() => {
      document
        .getElementById("finance-transaction-form")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 60);
  }

  async function deleteTransaction(id) {
    if (
      !window.confirm(
        "Bu finans hareketini silmek istiyor musunuz?"
      )
    ) {
      return;
    }

    try {
      await request(
        `${API_BASE}/cash/${id}`,
        {
          method: "DELETE",
          headers: authHeaders(),
        }
      );

      await loadRecords();

      setNotice("İşlem silindi.");
    } catch (err) {
      window.alert(
        err.message || "Kayıt silinemedi."
      );
    }
  }

  function saveEmployee() {
    if (
      !String(
        employeeForm.name || ""
      ).trim()
    ) {
      window.alert(
        "Personel adı zorunludur."
      );
      return;
    }

    let nextEmployees;

    if (editingEmployeeId) {
      nextEmployees = employees.map(
        (employee) =>
          String(employee.id) ===
          String(editingEmployeeId)
            ? {
                ...employeeForm,
                id: editingEmployeeId,
              }
            : employee
      );
    } else {
      nextEmployees = [
        ...employees,
        {
          ...employeeForm,
          id: `draft-${Date.now()}`,
        },
      ];
    }

    setEmployees(nextEmployees);

    localStorage.setItem(
      "cash_employee_draft",
      JSON.stringify(nextEmployees)
    );

    setEmployeeForm({
      ...EMPTY_EMPLOYEE,
      currency: filters.currency,
    });

    setEditingEmployeeId(null);

    setNotice(
      "Personel taslağı kaydedildi."
    );
  }

  function editEmployee(employee) {
    setEditingEmployeeId(employee.id);
    setEmployeeForm({ ...employee });
  }

  function deleteEmployee(id) {
    if (
      !window.confirm(
        "Bu personel kartını kaldırmak istiyor musunuz?"
      )
    ) {
      return;
    }

    const nextEmployees = employees.filter(
      (employee) =>
        String(employee.id) !== String(id)
    );

    setEmployees(nextEmployees);

    localStorage.setItem(
      "cash_employee_draft",
      JSON.stringify(nextEmployees)
    );

    if (
      String(editingEmployeeId) ===
      String(id)
    ) {
      setEmployeeForm({
        ...EMPTY_EMPLOYEE,
        currency: filters.currency,
      });

      setEditingEmployeeId(null);
    }
  }

  function selectPayrollEmployee(id) {
    const employee = employees.find(
      (item) =>
        String(item.id) === String(id)
    );

    setPayrollForm((current) => ({
      ...current,
      employee_id: id,
      gross: employee?.base_salary || "",
      currency:
        employee?.currency ||
        filters.currency,
    }));
  }

  async function savePayroll() {
    const employee = employees.find(
      (item) =>
        String(item.id) ===
        String(payrollForm.employee_id)
    );

    if (!employee) {
      window.alert(
        "Önce personel seçmelisiniz."
      );
      return;
    }

    if (!payrollForm.period) {
      window.alert(
        "Maaş dönemi zorunludur."
      );
      return;
    }

    if (payrollNet <= 0) {
      window.alert(
        "Net maaş tutarı sıfırdan büyük olmalıdır."
      );
      return;
    }

    setSaving(true);

    try {
      const periodLabel =
        payrollForm.period
          .split("-")
          .reverse()
          .join(".");

      await request(`${API_BASE}/cash`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          module_type: "payroll",
          transaction_type: "expense",
          title: `${employee.name} - ${periodLabel} Maaş Ödemesi`,
          category: "Maaş ve Ücretler",
          quantity: 1,
          unit_price: payrollNet,
          total_amount: payrollNet,
          currency: payrollForm.currency,
          payment_method:
            payrollForm.payment_method,
          customer_name: "",
          staff_name: employee.name,
          note: [
            `Dönem: ${payrollForm.period}`,
            `Brüt: ${numberValue(
              payrollForm.gross
            )}`,
            `Prim: ${numberValue(
              payrollForm.bonus
            )}`,
            `Kesinti: ${numberValue(
              payrollForm.deduction
            )}`,
            payrollForm.note || "",
          ]
            .filter(Boolean)
            .join(" | "),
          transaction_date:
            payrollForm.payment_date ||
            localDate(),
        }),
      });

      setPayrollForm({
        ...EMPTY_PAYROLL,
        period: currentMonth(),
        payment_date: localDate(),
        currency:
          employee.currency ||
          filters.currency,
      });

      await loadRecords();

      setNotice(
        "Maaş ödemesi kasaya kaydedildi."
      );
    } catch (err) {
      window.alert(
        err.message ||
          "Maaş ödemesi kaydedilemedi."
      );
    } finally {
      setSaving(false);
    }
  }
  function saveCompanyDraft() {
    localStorage.setItem(
      "cash_company_draft",
      JSON.stringify(company)
    );

    if (company.default_currency) {
      setFilters((current) => ({
        ...current,
        currency: company.default_currency,
      }));
    }

    setNotice(
      "Firma bilgileri taslak olarak kaydedildi."
    );
  }

  function handleLogoFile(event) {
    const file = event.target.files?.[0];

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      window.alert(
        "Lütfen bir görsel dosyası seçin."
      );
      return;
    }

    if (file.size > 700 * 1024) {
      window.alert(
        "Logo dosyası 700 KB'dan küçük olmalıdır."
      );
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      setCompany((current) => ({
        ...current,
        logo: String(reader.result || ""),
      }));
    };

    reader.readAsDataURL(file);
  }

  function exportCSV() {
    const rows = [
      [
        tx("date"),
        tx("type"),
        tx("source"),
        tx("recordTitle"),
        tx("category"),
        tx("amount"),
        tx("currency"),
        tx("payment"),
        tx("related"),
        tx("staff"),
      ],
      ...filteredRecords.map((record) => [
        String(
          record.transaction_date || ""
        ).slice(0, 10),
        record.transaction_type,
        record.module_type,
        record.title,
        record.category,
        record.total_amount,
        record.currency,
        record.payment_method,
        record.customer_name,
        record.staff_name,
      ]),
    ];

    const csv = rows
      .map((row) =>
        row
          .map(
            (cell) =>
              `"${String(cell ?? "").replace(
                /"/g,
                '""'
              )}"`
          )
          .join(";")
      )
      .join("\n");

    const url = URL.createObjectURL(
      new Blob(["\uFEFF" + csv], {
        type: "text/csv;charset=utf-8",
      })
    );

    const anchor =
      document.createElement("a");

    anchor.href = url;
    anchor.download = `kurumsal-finans-raporu-${localDate()}.csv`;

    document.body.appendChild(anchor);

    anchor.click();
    anchor.remove();

    URL.revokeObjectURL(url);
  }

  function printCorporateReport() {
    const companyName =
      company.legal_name ||
      company.display_name ||
      "Kurum / Firma Adı";

    const payrollRows = payrollByStaff
      .map(
        (item) => `
          <tr>
            <td>${escapeHtml(item.name)}</td>
            <td>${item.count}</td>
            <td>${escapeHtml(
              item.lastDate || "-"
            )}</td>
            <td class="num">${escapeHtml(
              money(
                item.total,
                filters.currency,
                lang
              )
            )}</td>
          </tr>
        `
      )
      .join("");

    const categoryRows = categorySummary
      .map(
        (item) => `
          <tr>
            <td>${escapeHtml(item.name)}</td>
            <td>${escapeHtml(
              item.type === "expense"
                ? "Gider"
                : "Gelir"
            )}</td>
            <td>${item.count}</td>
            <td class="num">${escapeHtml(
              money(
                item.total,
                filters.currency,
                lang
              )
            )}</td>
          </tr>
        `
      )
      .join("");

    const transactionRows =
      filteredRecords
        .map(
          (record) => `
            <tr>
              <td>
                ${escapeHtml(
                  String(
                    record.transaction_date || ""
                  ).slice(0, 10)
                )}
              </td>

              <td>
                <b>${escapeHtml(
                  record.title || "-"
                )}</b>

                <small>
                  ${escapeHtml(
                    record.category || "-"
                  )}
                </small>
              </td>

              <td>
                ${escapeHtml(
                  label(
                    MODULE_LABELS,
                    record.module_type ||
                      "manual"
                  )
                )}
              </td>

              <td>
                ${escapeHtml(
                  record.staff_name ||
                    record.customer_name ||
                    "-"
                )}
              </td>

              <td>
                ${escapeHtml(
                  label(
                    PAYMENT_LABELS,
                    record.payment_method ||
                      "other"
                  )
                )}
              </td>

              <td class="num ${
                record.transaction_type ===
                "expense"
                  ? "red"
                  : "green"
              }">
                ${
                  record.transaction_type ===
                  "expense"
                    ? "−"
                    : "+"
                }

                ${escapeHtml(
                  money(
                    record.total_amount,
                    record.currency,
                    lang
                  )
                )}
              </td>
            </tr>
          `
        )
        .join("");

    const logo = company.logo
      ? `
        <img
          class="logo"
          src="${escapeHtml(company.logo)}"
          alt="Logo"
        />
      `
      : `
        <div class="logo-placeholder">
          ${escapeHtml(
            companyName
              .slice(0, 2)
              .toUpperCase()
          )}
        </div>
      `;

    const html = `
      <!doctype html>
      <html lang="tr">
        <head>
          <meta charset="utf-8" />

          <title>
            ${escapeHtml(companyName)}
            - Kurumsal Finans Raporu
          </title>

          <style>
            * {
              box-sizing: border-box;
            }

            body {
              margin: 0;
              padding: 28px;
              font-family: Arial, sans-serif;
              color: #14283f;
              background: #ffffff;
            }

            .print-btn {
              position: fixed;
              right: 24px;
              top: 20px;
              border: 0;
              border-radius: 9px;
              padding: 10px 16px;
              background: #f58220;
              color: #ffffff;
              font-weight: 700;
              cursor: pointer;
            }

            .header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 20px;
              padding-bottom: 18px;
              border-bottom: 4px solid #0b4d8b;
            }

            .brand {
              display: flex;
              align-items: center;
              gap: 15px;
            }

            .logo,
            .logo-placeholder {
              width: 72px;
              height: 72px;
              object-fit: contain;
              border: 1px solid #dce5ee;
              border-radius: 14px;
            }

            .logo-placeholder {
              display: flex;
              align-items: center;
              justify-content: center;
              background: #eaf3fb;
              color: #0b4d8b;
              font-size: 24px;
              font-weight: 900;
            }

            h1 {
              margin: 0 0 5px;
              font-size: 23px;
            }

            .brand p,
            .meta p {
              margin: 3px 0;
              color: #617286;
              font-size: 11px;
            }

            .meta {
              text-align: right;
            }

            .report-title {
              padding: 17px 0 8px;
            }

            .report-title h2 {
              margin: 0;
              font-size: 18px;
            }

            .report-title p {
              margin: 5px 0;
              color: #6d7d8f;
              font-size: 11px;
            }

            .cards {
              display: grid;
              grid-template-columns:
                repeat(4, 1fr);
              gap: 10px;
              margin: 14px 0 20px;
            }

            .card {
              padding: 13px;
              border: 1px solid #dfe7ef;
              border-radius: 11px;
            }

            .card span {
              display: block;
              color: #6d7d8f;
              font-size: 9px;
              text-transform: uppercase;
              font-weight: 700;
            }

            .card b {
              display: block;
              margin-top: 6px;
              font-size: 17px;
            }

            .green {
              color: #147649;
            }

            .red {
              color: #c23d3d;
            }

            .blue {
              color: #0b4d8b;
            }

            .violet {
              color: #6e53af;
            }

            h3 {
              margin: 21px 0 8px;
              padding-left: 9px;
              border-left: 4px solid #f58220;
              font-size: 14px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 9px;
            }

            th {
              padding: 8px;
              background: #0b4d8b;
              color: #ffffff;
              text-align: left;
            }

            td {
              padding: 7px;
              border-bottom: 1px solid #e3e9ef;
              vertical-align: top;
            }

            td small {
              display: block;
              margin-top: 2px;
              color: #718195;
            }

            .num {
              text-align: right;
              white-space: nowrap;
            }

            .footer {
              display: flex;
              justify-content: space-between;
              gap: 25px;
              margin-top: 28px;
              padding-top: 13px;
              border-top: 1px solid #dfe6ed;
              color: #68788a;
              font-size: 9px;
            }

            .signature {
              width: 210px;
              text-align: center;
              padding-top: 24px;
              border-bottom: 1px solid #768495;
            }

            .note {
              max-width: 65%;
              line-height: 1.5;
            }

            @media print {
              body {
                padding: 0;
              }

              .print-btn {
                display: none;
              }

              .page-break {
                break-before: page;
              }
            }
          </style>
        </head>

        <body>
          <button
            class="print-btn"
            onclick="window.print()"
          >
            Yazdır / PDF
          </button>

          <div class="header">
            <div class="brand">
              ${logo}

              <div>
                <h1>
                  ${escapeHtml(companyName)}
                </h1>

                <p>
                  ${escapeHtml(
                    company.address || ""
                  )}
                </p>

                <p>
                  ${escapeHtml(
                    [
                      company.phone,
                      company.email,
                      company.website,
                    ]
                      .filter(Boolean)
                      .join(" · ")
                  )}
                </p>
              </div>
            </div>

            <div class="meta">
              <p>
                <b>Vergi Dairesi:</b>
                ${escapeHtml(
                  company.tax_office || "-"
                )}
              </p>

              <p>
                <b>Vergi No:</b>
                ${escapeHtml(
                  company.tax_number || "-"
                )}
              </p>

              <p>
                <b>Sicil No:</b>
                ${escapeHtml(
                  company.registry_number || "-"
                )}
              </p>
            </div>
          </div>

          <div class="report-title">
            <h2>
              Kurumsal Gelir–Gider ve
              Personel Raporu
            </h2>

            <p>
              Dönem:
              ${escapeHtml(
                filters.start || "Başlangıç"
              )}
              –
              ${escapeHtml(
                filters.end || "Bugün"
              )}

              · Para Birimi:
              ${escapeHtml(filters.currency)}

              · Oluşturulma:
              ${escapeHtml(
                new Date().toLocaleString(
                  "tr-TR"
                )
              )}
            </p>
          </div>

          <div class="cards">
            <div class="card">
              <span>Toplam Gelir</span>

              <b class="green">
                ${escapeHtml(
                  money(
                    totals.income,
                    filters.currency,
                    lang
                  )
                )}
              </b>
            </div>

            <div class="card">
              <span>Toplam Gider</span>

              <b class="red">
                ${escapeHtml(
                  money(
                    totals.expense,
                    filters.currency,
                    lang
                  )
                )}
              </b>
            </div>

            <div class="card">
              <span>Net Durum</span>

              <b class="blue">
                ${escapeHtml(
                  money(
                    net,
                    filters.currency,
                    lang
                  )
                )}
              </b>
            </div>

            <div class="card">
              <span>Maaş Ödemeleri</span>

              <b class="violet">
                ${escapeHtml(
                  money(
                    totals.payroll,
                    filters.currency,
                    lang
                  )
                )}
              </b>
            </div>
          </div>

          <h3>
            Personel Bazlı Maaş Özeti
          </h3>

          <table>
            <thead>
              <tr>
                <th>Personel</th>
                <th>Ödeme Adedi</th>
                <th>Son Ödeme</th>
                <th class="num">Toplam</th>
              </tr>
            </thead>

            <tbody>
              ${
                payrollRows ||
                `
                  <tr>
                    <td colspan="4">
                      Maaş kaydı bulunamadı.
                    </td>
                  </tr>
                `
              }
            </tbody>
          </table>

          <h3>
            Kategori Bazlı Gelir–Gider
            Özeti
          </h3>

          <table>
            <thead>
              <tr>
                <th>Kategori</th>
                <th>Tür</th>
                <th>Kayıt</th>
                <th class="num">Toplam</th>
              </tr>
            </thead>

            <tbody>
              ${
                categoryRows ||
                `
                  <tr>
                    <td colspan="4">
                      Kategori kaydı
                      bulunamadı.
                    </td>
                  </tr>
                `
              }
            </tbody>
          </table>

          <h3 class="page-break">
            Ayrıntılı Finans Hareketleri
          </h3>

          <table>
            <thead>
              <tr>
                <th>Tarih</th>
                <th>İşlem</th>
                <th>Kaynak</th>
                <th>İlgili Kişi</th>
                <th>Ödeme</th>
                <th class="num">Tutar</th>
              </tr>
            </thead>

            <tbody>
              ${
                transactionRows ||
                `
                  <tr>
                    <td colspan="6">
                      İşlem bulunamadı.
                    </td>
                  </tr>
                `
              }
            </tbody>
          </table>

          <div class="footer">
            <div class="note">
              <b>Rapor Notu:</b>
              <br />

              ${escapeHtml(
                company.report_note ||
                  DEFAULT_COMPANY.report_note
              )}

              <br />

              <b>IBAN:</b>

              ${escapeHtml(
                company.iban || "-"
              )}
            </div>

            <div>
              <div class="signature">
                ${escapeHtml(
                  company.authorized_person ||
                    "Yetkili Adı / İmza"
                )}
              </div>
            </div>
          </div>
        </body>
      </html>
    `;

    const reportWindow = window.open(
      "",
      "_blank"
    );

    if (!reportWindow) {
      window.alert(
        "Rapor penceresi açılamadı. Açılır pencereye izin verin."
      );
      return;
    }

    reportWindow.document.open();
    reportWindow.document.write(html);
    reportWindow.document.close();
  }

  function renderFilters() {
    return (
      <div
        className={`finance-filters ${
          mobileFilters ? "open" : ""
        }`}
      >
        <Field
          label={tx("search")}
          className="filter-wide"
        >
          <input
            value={filters.q}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                q: event.target.value,
              }))
            }
            placeholder="Başlık, kişi, kategori veya not..."
          />
        </Field>

        <Field label={tx("type")}>
          <select
            value={filters.type}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                type: event.target.value,
              }))
            }
          >
            <option value="all">
              {tx("all")}
            </option>

            <option value="income">
              Gelir
            </option>

            <option value="expense">
              Gider
            </option>
          </select>
        </Field>

        <Field label={tx("source")}>
          <select
            value={filters.module}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                module: event.target.value,
              }))
            }
          >
            <option value="all">
              {tx("all")}
            </option>

            {modules.map((module) => (
              <option
                key={module}
                value={module}
              >
                {label(
                  MODULE_LABELS,
                  module
                )}
              </option>
            ))}
          </select>
        </Field>

        <Field label={tx("category")}>
          <select
            value={filters.category}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                category:
                  event.target.value,
              }))
            }
          >
            <option value="all">
              {tx("all")}
            </option>

            {categories.map((category) => (
              <option
                key={category}
                value={category}
              >
                {category}
              </option>
            ))}
          </select>
        </Field>

        <Field label={tx("payment")}>
          <select
            value={filters.payment}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                payment:
                  event.target.value,
              }))
            }
          >
            <option value="all">
              {tx("all")}
            </option>

            {Object.keys(
              PAYMENT_LABELS
            ).map((payment) => (
              <option
                key={payment}
                value={payment}
              >
                {label(
                  PAYMENT_LABELS,
                  payment
                )}
              </option>
            ))}
          </select>
        </Field>

        <Field label={tx("staff")}>
          <select
            value={filters.staff}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                staff: event.target.value,
              }))
            }
          >
            <option value="all">
              {tx("all")}
            </option>

            {staffNames.map((staff) => (
              <option
                key={staff}
                value={staff}
              >
                {staff}
              </option>
            ))}
          </select>
        </Field>

        <Field label={tx("branch")}>
          <select
            value={filters.branch}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                branch:
                  event.target.value,
              }))
            }
          >
            <option value="all">
              {tx("all")}
            </option>

            {branches.map((branch) => (
              <option
                key={branch}
                value={branch}
              >
                {/^[0-9]+$/.test(branch)
                  ? `Şube ${branch}`
                  : branch}
              </option>
            ))}
          </select>
        </Field>

        <Field label={tx("start")}>
          <input
            type="date"
            value={filters.start}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                start: event.target.value,
                period: "custom",
              }))
            }
          />
        </Field>

        <Field label={tx("end")}>
          <input
            type="date"
            value={filters.end}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                end: event.target.value,
                period: "custom",
              }))
            }
          />
        </Field>

        <button
          type="button"
          className="filter-clear"
          onClick={clearFilters}
        >
          {tx("clear")}
        </button>
      </div>
    );
  }

  function renderRecordsTable(
    data,
    showActions = true
  ) {
    if (!data.length) {
      return (
        <EmptyState text={tx("noData")} />
      );
    }

    return (
      <div className="records-wrap">
        <div className="records-count">
          <b>{data.length}</b> kayıt
          listeleniyor
        </div>

        <div className="table-scroll">
          <table className="finance-table">
            <thead>
              <tr>
                <th>{tx("date")}</th>
                <th>{tx("recordTitle")}</th>
                <th>{tx("source")}</th>
                <th>{tx("related")}</th>
                <th>{tx("payment")}</th>

                <th className="right">
                  {tx("amount")}
                </th>

                {showActions && (
                  <th className="right">
                    {tx("actions")}
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {data.map((record) => {
                const isExpense =
                  record.transaction_type ===
                  "expense";

                return (
                  <tr key={record.id}>
                    <td className="date-cell">
                      {String(
                        record.transaction_date ||
                          ""
                      ).slice(0, 10) || "-"}
                    </td>

                    <td>
                      <div className="transaction-name">
                        <span
                          className={`type-dot ${
                            isExpense
                              ? "expense"
                              : "income"
                          }`}
                        />

                        <div>
                          <b>
                            {record.title ||
                              "Başlıksız işlem"}
                          </b>

                          <small>
                            {record.category ||
                              "Kategori belirtilmedi"}
                          </small>
                        </div>
                      </div>
                    </td>

                    <td>
                      <span className="source-badge">
                        {label(
                          MODULE_LABELS,
                          record.module_type ||
                            "manual"
                        )}
                      </span>
                    </td>

                    <td>
                      <b className="related-name">
                        {record.staff_name ||
                          record.customer_name ||
                          "-"}
                      </b>

                      {record.staff_name &&
                        record.customer_name && (
                          <small className="subtext">
                            {
                              record.customer_name
                            }
                          </small>
                        )}
                    </td>

                    <td>
                      {label(
                        PAYMENT_LABELS,
                        record.payment_method ||
                          "other"
                      )}
                    </td>

                    <td
                      className={`right amount-cell ${
                        isExpense
                          ? "negative"
                          : "positive"
                      }`}
                    >
                      {isExpense ? "−" : "+"}

                      {money(
                        record.total_amount,
                        record.currency ||
                          "TRY",
                        lang
                      )}
                    </td>

                    {showActions && (
                      <td className="right">
                        <div className="row-actions">
                          <button
                            type="button"
                            onClick={() =>
                              editTransaction(
                                record
                              )
                            }
                          >
                            {tx("edit")}
                          </button>

                          <button
                            type="button"
                            className="danger"
                            onClick={() =>
                              deleteTransaction(
                                record.id
                              )
                            }
                          >
                            {tx("delete")}
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  function renderTransactionForm() {
    if (!showTransactionForm) {
      return null;
    }

    return (
      <section
        className="panel form-panel"
        id="finance-transaction-form"
      >
        <SectionTitle
          eyebrow={
            editingId
              ? "KAYIT DÜZENLEME"
              : "YENİ FİNANS HAREKETİ"
          }
          title={
            editingId
              ? "Finans hareketini güncelle"
              : "Gelir veya gider kaydı oluştur"
          }
          description="İşlem kaynağını ve kategorisini doğru seçmeniz raporların güvenilir olmasını sağlar."
        />

        <div className="type-switch">
          <button
            type="button"
            className={
              form.transaction_type ===
              "income"
                ? "active income"
                : ""
            }
            onClick={() =>
              setForm((current) => ({
                ...current,
                transaction_type:
                  "income",
                category: "",
              }))
            }
          >
            <span>↗</span> Gelir
          </button>

          <button
            type="button"
            className={
              form.transaction_type ===
              "expense"
                ? "active expense"
                : ""
            }
            onClick={() =>
              setForm((current) => ({
                ...current,
                transaction_type:
                  "expense",
                category: "",
              }))
            }
          >
            <span>↘</span> Gider
          </button>
        </div>

        <div className="form-grid transaction-grid">
          <Field
            label="Kaynak / İşlem Grubu"
            required
          >
            <select
  value={form.module_type}
  onChange={(event) => {
    setCustomerSearch("");

    setForm((current) => ({
      ...current,
      module_type: event.target.value,
      customer_id: "",
      cari_customer_id: "",
      beauty_customer_id: "",
      customer_name: "",
    }));
  }}
>
              {modules.map((module) => (
                <option
                  key={module}
                  value={module}
                >
                  {label(
                    MODULE_LABELS,
                    module
                  )}
                </option>
              ))}
            </select>
          </Field>

          <Field
            label="İşlem Başlığı"
            required
            className="span-2"
          >
            <input
              value={form.title}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  title: event.target.value,
                }))
              }
              placeholder="Örn. Temmuz ayı ofis kirası"
            />
          </Field>

          <Field label="Kategori" required>
            <select
              value={form.category}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  category:
                    event.target.value,
                }))
              }
            >
              <option value="">
                Kategori seçin
              </option>

              {categoryOptions.map(
                (category) => (
                  <option
                    key={category}
                    value={category}
                  >
                    {category}
                  </option>
                )
              )}
            </select>
          </Field>




<Field
  label="Cari Ara / Tahsilat Yaz"
  className="span-2"
>
  <div className="customer-picker">
    <div className="customer-search-row">
      <input
        value={customerSearch}
        onChange={(event) => {
          setCustomerSearch(event.target.value);

          setForm((current) => ({
            ...current,
            customer_id: "",
            cari_customer_id: "",
            beauty_customer_id: "",
            customer_name: "",
          }));
        }}
        placeholder="Cari adı, telefon veya e-posta ile ara"
      />

      {(form.cari_customer_id ||
        form.beauty_customer_id) && (
        <button
          type="button"
          className="customer-clear"
          onClick={clearSelectedCustomer}
        >
          Seçimi Kaldır
        </button>
      )}
    </div>

    {!form.cari_customer_id &&
      !form.beauty_customer_id &&
      customerSearchResults.length > 0 && (
        <div className="customer-results">
          {customerSearchResults.map((customer) => (
            <button
              type="button"
              key={customer.key}
              onClick={() =>
                selectCustomer(customer)
              }
            >
              <strong>
                {customer.display_name || "-"}
              </strong>

              <span>
                {customer.phone ||
                  customer.email ||
                  "İletişim bilgisi yok"}
              </span>
            </button>
          ))}
        </div>
      )}

    {(form.cari_customer_id ||
      form.beauty_customer_id) && (
      <div className="selected-customer">
        <span>Seçili Cari</span>

        <strong>
          {form.customer_name || "-"}
        </strong>

        <small>
          Gelir kaydı bu carinin tahsilatına
          bağlanacaktır.
        </small>
      </div>
    )}
  </div>
</Field>

          <Field label="İlgili Personel">













            <input
              list="finance-staff-list"
              value={form.staff_name}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  staff_name:
                    event.target.value,
                }))
              }
              placeholder="Personel adı"
            />

            <datalist id="finance-staff-list">
              {staffNames.map((staff) => (
                <option
                  key={staff}
                  value={staff}
                />
              ))}
            </datalist>
          </Field>

          <Field
            label="İşlem Tarihi"
            required
          >
            <input
              type="date"
              value={form.transaction_date}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  transaction_date:
                    event.target.value,
                }))
              }
            />
          </Field>

          <Field label="Adet / Miktar">
            <input
              type="number"
              min="0"
              step="0.01"
              value={form.quantity}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  quantity:
                    event.target.value,
                  total_amount: "",
                }))
              }
            />
          </Field>

          <Field label="Birim Fiyat">
            <input
              type="number"
              min="0"
              step="0.01"
              value={form.unit_price}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  unit_price:
                    event.target.value,
                  total_amount: "",
                }))
              }
              placeholder="0,00"
            />
          </Field>

          <Field
            label="Toplam Tutar"
            required
          >
            <input
              type="number"
              min="0"
              step="0.01"
              value={form.total_amount}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  total_amount:
                    event.target.value,
                }))
              }
              placeholder="Otomatik veya elle"
            />
          </Field>

          <Field label="Para Birimi">
            <select
              value={form.currency}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  currency:
                    event.target.value,
                }))
              }
            >
              {currencies.map((currency) => (
                <option
                  key={currency}
                  value={currency}
                >
                  {currency}
                </option>
              ))}
            </select>
          </Field>

          <Field label="Ödeme Yöntemi">
            <select
              value={form.payment_method}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  payment_method:
                    event.target.value,
                }))
              }
            >
              {Object.keys(
                PAYMENT_LABELS
              ).map((payment) => (
                <option
                  key={payment}
                  value={payment}
                >
                  {label(
                    PAYMENT_LABELS,
                    payment
                  )}
                </option>
              ))}
            </select>
          </Field>

          <Field
            label="Açıklama / Belge Notu"
            className="span-2"
          >
            <textarea
              rows="3"
              value={form.note}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  note: event.target.value,
                }))
              }
              placeholder="Fatura no, belge açıklaması veya işlem notu..."
            />
          </Field>
        </div>

        <div className="form-summary">
          <div>
            <span>Kaydedilecek tutar</span>

            <b>
              {money(
                effectiveAmount,
                form.currency,
                lang
              )}
            </b>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn ghost"
              onClick={() => {
                resetTransactionForm();
                setShowTransactionForm(false);
              }}
            >
              {tx("cancel")}
            </button>

            <button
              type="button"
              className="btn primary"
              disabled={saving}
              onClick={saveTransaction}
            >
              {saving
                ? "Kaydediliyor..."
                : editingId
                  ? tx("update")
                  : tx("save")}
            </button>
          </div>
        </div>
      </section>
    );
  }

  if (loading) {
    return (
      <>
        <div className="finance-loading">
          <div className="loading-mark">
            <i />
            <i />
            <i />
          </div>

          <b>{tx("loading")}</b>

          <span>
            Kasa ve entegrasyon kayıtları
            kontrol ediliyor.
          </span>
        </div>

        <style>{FINANCE_STYLES}</style>
      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="finance-loading error-state">
          <div className="error-icon">
            !
          </div>

          <b>
            Finans verileri alınamadı
          </b>

          <span>{error}</span>

          <button
            type="button"
            className="btn primary"
            onClick={loadRecords}
          >
            {tx("retry")}
          </button>
        </div>

        <style>{FINANCE_STYLES}</style>
      </>
    );
  }

  const tabs = [
    ["overview", "01", tx("overview")],
    ["movements", "02", tx("movements")],
    ["payroll", "03", tx("payroll")],
    ["reports", "04", tx("reports")],
    ["company", "05", tx("company")],
    ["training", "06", tx("training")],
  ];


  return (
    <div className="finance-app">
      {notice && (
        <div className="finance-notice">
          <span>✓</span>
          {notice}
        </div>
      )}

      <section className="finance-hero">
        <div className="hero-copy">
          <span className="hero-eyebrow">
            <i /> {tx("eyebrow")}
          </span>

          <h1>{tx("title")}</h1>
          <p>{tx("subtitle")}</p>

          <div className="hero-status">
            <span>
              <i className="online" />
              Sistem aktif
            </span>

            <span>
              {records.length} finans hareketi
            </span>

            <span>
              {currencies.length} para birimi
            </span>
          </div>
        </div>

        <div className="hero-actions">
          <button
            type="button"
            className="hero-btn secondary"
            onClick={loadRecords}
          >
            ↻ <span>{tx("refresh")}</span>
          </button>

          <button
            type="button"
            className="hero-btn secondary"
            onClick={exportCSV}
          >
            ⇩ <span>{tx("csv")}</span>
          </button>

          <button
            type="button"
            className="hero-btn secondary"
            onClick={printCorporateReport}
          >
            ▤ <span>{tx("print")}</span>
          </button>

          <button
            type="button"
            className="hero-btn primary"
            onClick={() =>
              openNewTransaction()
            }
          >
            ＋ <span>{tx("newRecord")}</span>
          </button>
        </div>
      </section>

      <nav
        className="finance-tabs"
        aria-label="Finans modülü bölümleri"
      >
        {tabs.map(
          ([key, number, title]) => (
            <button
              key={key}
              type="button"
              className={
                activeTab === key
                  ? "active"
                  : ""
              }
              onClick={() =>
                setActiveTab(key)
              }
            >
              <span>{number}</span>
              {title}
            </button>
          )
        )}
      </nav>

      <section className="context-bar">
        <div className="period-pills">
          {[
            ["today", tx("today")],
            ["week", tx("week")],
            ["month", tx("month")],
            ["year", tx("year")],
            ["all", tx("allTime")],
          ].map(([key, text]) => (
            <button
              key={key}
              type="button"
              className={
                filters.period === key
                  ? "active"
                  : ""
              }
              onClick={() => setPeriod(key)}
            >
              {text}
            </button>
          ))}
        </div>

        <div className="currency-select">
          <span>{tx("currency")}</span>

          <select
            value={filters.currency}
            onChange={(event) =>
              setFilters((current) => ({
                ...current,
                currency:
                  event.target.value,
              }))
            }
          >
            {currencies.map((currency) => (
              <option
                key={currency}
                value={currency}
              >
                {currency}
              </option>
            ))}
          </select>
        </div>
      </section>

      <main className="finance-main">
        {activeTab === "overview" && (
          <>
            <section className="metrics-grid">
              <Metric
                icon="↗"
                tone="green"
                label={tx("income")}
                value={money(
                  totals.income,
                  filters.currency,
                  lang
                )}
                detail={`${
                  filteredRecords.filter(
                    (record) =>
                      record.transaction_type !==
                      "expense"
                  ).length
                } gelir kaydı`}
              />

              <Metric
                icon="↘"
                tone="red"
                label={tx("expense")}
                value={money(
                  totals.expense,
                  filters.currency,
                  lang
                )}
                detail={`${
                  filteredRecords.filter(
                    (record) =>
                      record.transaction_type ===
                      "expense"
                  ).length
                } gider kaydı`}
              />

              <Metric
                icon="="
                tone={
                  net >= 0 ? "blue" : "red"
                }
                label={tx("net")}
                value={money(
                  net,
                  filters.currency,
                  lang
                )}
                detail={
                  net >= 0
                    ? "Gelirler giderlerden yüksek"
                    : "Giderler gelirlerden yüksek"
                }
              />

              <Metric
                icon="₺"
                tone="violet"
                label={tx("payrollTotal")}
                value={money(
                  totals.payroll,
                  filters.currency,
                  lang
                )}
                detail={`${payrollRecords.length} personel ödemesi`}
              />
            </section>

            <section className="panel">
              <SectionTitle
                eyebrow="SIK KULLANILANLAR"
                title={tx("quick")}
                description="Kayıt türünü hazır seçerek işlemi daha hızlı oluşturun."
              />

              <div className="quick-grid">
                {QUICK_TEMPLATES.map(
                  (template) => (
                    <button
                      key={template[1]}
                      type="button"
                      onClick={() =>
                        openNewTransaction(
                          template
                        )
                      }
                    >
                      <span
                        className={`quick-icon ${template[7]}`}
                      >
                        {template[0]}
                      </span>

                      <span>
                        <b>{template[1]}</b>
                        <small>
                          {template[2]}
                        </small>
                      </span>

                      <em>›</em>
                    </button>
                  )
                )}
              </div>
            </section>

            <div className="overview-columns">
              <section className="panel expense-panel">
                <SectionTitle
                  eyebrow="SEÇİLİ DÖNEM"
                  title={tx(
                    "expenseBreakdown"
                  )}
                  description="En yüksek gider kategorileriniz."
                />

                {expenseGroups.length ? (
                  <div className="expense-list">
                    {expenseGroups.map(
                      (item, index) => {
                        const percent =
                          totals.expense
                            ? Math.round(
                                (item.total /
                                  totals.expense) *
                                  100
                              )
                            : 0;

                        return (
                          <div
                            className="expense-row"
                            key={`${item.name}-${item.type}`}
                          >
                            <span className="rank">
                              {String(
                                index + 1
                              ).padStart(2, "0")}
                            </span>

                            <div className="expense-info">
                              <div>
                                <b>
                                  {item.name}
                                </b>

                                <span>
                                  {item.count} işlem
                                  · %{percent}
                                </span>
                              </div>

                              <i>
                                <em
                                  style={{
                                    width: `${Math.max(
                                      percent,
                                      3
                                    )}%`,
                                  }}
                                />
                              </i>
                            </div>

                            <strong>
                              {money(
                                item.total,
                                filters.currency,
                                lang
                              )}
                            </strong>
                          </div>
                        );
                      }
                    )}
                  </div>
                ) : (
                  <EmptyState text="Seçili dönemde gider kaydı bulunmuyor." />
                )}
              </section>

              <aside className="panel health-card">
                <span className="health-score">
                  {totals.income
                    ? Math.max(
                        0,
                        Math.min(
                          100,
                          Math.round(
                            (net /
                              totals.income) *
                              100 +
                              50
                          )
                        )
                      )
                    : 0}
                </span>

                <small>
                  FİNANSAL DENGE SKORU
                </small>

                <h3>
                  {net >= 0
                    ? "Dengeli görünüm"
                    : "Gider kontrolü gerekli"}
                </h3>

                <p>
                  Seçili dönemde gelirlerin %
                  {totals.income
                    ? Math.round(
                        (totals.expense /
                          totals.income) *
                          100
                      )
                    : 0}
                  'ı giderlere ayrıldı.
                </p>

                <button
                  type="button"
                  onClick={() =>
                    setActiveTab("reports")
                  }
                >
                  Ayrıntılı raporu incele →
                </button>
              </aside>
            </div>

            <section className="panel">
              <SectionTitle
                eyebrow="CANLI KASA"
                title={tx("latest")}
                description="En son kaydedilen finans hareketleri."
                action={
                  <button
                    type="button"
                    className="text-btn"
                    onClick={() =>
                      setActiveTab(
                        "movements"
                      )
                    }
                  >
                    Tümünü görüntüle →
                  </button>
                }
              />

              {renderRecordsTable(
                filteredRecords.slice(0, 8)
              )}
            </section>
          </>
        )}

        {activeTab === "movements" && (
          <>
            <section className="panel filters-panel">
              <SectionTitle
                eyebrow="ARAMA VE FİLTRELEME"
                title={tx("movements")}
                description="Tüm modüllerden gelen ve elle girilen kasa hareketlerini tek ekranda yönetin."
                action={
                  <button
                    type="button"
                    className="btn compact primary"
                    onClick={() =>
                      openNewTransaction()
                    }
                  >
                    ＋ {tx("newRecord")}
                  </button>
                }
              />

              <button
                type="button"
                className="mobile-filter-toggle"
                onClick={() =>
                  setMobileFilters(
                    (current) => !current
                  )
                }
              >
                ☰ {tx("filters")}
              </button>

              {renderFilters()}
            </section>

            {renderTransactionForm()}

            <section className="panel table-panel">
              {renderRecordsTable(
                filteredRecords
              )}
            </section>
          </>
        )}

        {activeTab === "payroll" && (
          <>
            <div className="draft-banner">
              <span>i</span>

              <div>
                <b>
                  Frontend personel taslağı
                </b>

                <p>
                  {tx("frontendDraft")} Maaş
                  ödemeleri mevcut kasa
                  API'sine gider olarak
                  kaydedilir.
                </p>
              </div>
            </div>

            <div className="payroll-layout">
              <section className="panel employee-form-panel">
                <SectionTitle
                  eyebrow="PERSONEL YÖNETİMİ"
                  title={tx("addStaff")}
                  description="Maaş ödemelerinde kullanılacak personel kartını hazırlayın."
                />

                <div className="form-grid two-col">
                  <Field
                    label="Ad Soyad"
                    required
                  >
                    <input
                      value={
                        employeeForm.name
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            name:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Personelin adı soyadı"
                    />
                  </Field>

                  <Field label="Görev / Ünvan">
                    <input
                      value={
                        employeeForm.role
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            role:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Örn. Uzman, Müdür"
                    />
                  </Field>

                  <Field label="Şube / Birim">
                    <input
                      value={
                        employeeForm.branch
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            branch:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Merkez"
                    />
                  </Field>

                  <Field label="Aylık Brüt Ücret">
                    <input
                      type="number"
                      min="0"
                      value={
                        employeeForm.base_salary
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            base_salary:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="0,00"
                    />
                  </Field>

                  <Field label="Para Birimi">
                    <select
                      value={
                        employeeForm.currency
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            currency:
                              event.target
                                .value,
                          })
                        )
                      }
                    >
                      {currencies.map(
                        (currency) => (
                          <option
                            key={currency}
                          >
                            {currency}
                          </option>
                        )
                      )}
                    </select>
                  </Field>

                  <Field label="Telefon">
                    <input
                      value={
                        employeeForm.phone
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            phone:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="+90 ..."
                    />
                  </Field>

                  <Field
                    label="IBAN"
                    className="span-2"
                  >
                    <input
                      value={
                        employeeForm.iban
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            iban:
                              event.target.value.toUpperCase(),
                          })
                        )
                      }
                      placeholder="TR00 0000 0000 0000 0000 0000 00"
                    />
                  </Field>

                  <label className="checkbox-field span-2">
                    <input
                      type="checkbox"
                      checked={
                        employeeForm.active
                      }
                      onChange={(event) =>
                        setEmployeeForm(
                          (current) => ({
                            ...current,
                            active:
                              event.target
                                .checked,
                          })
                        )
                      }
                    />

                    <span>Aktif personel</span>
                  </label>
                </div>

                <div className="form-actions end">
                  {editingEmployeeId && (
                    <button
                      type="button"
                      className="btn ghost"
                      onClick={() => {
                        setEmployeeForm({
                          ...EMPTY_EMPLOYEE,
                          currency:
                            filters.currency,
                        });

                        setEditingEmployeeId(
                          null
                        );
                      }}
                    >
                      Vazgeç
                    </button>
                  )}

                  <button
                    type="button"
                    className="btn primary"
                    onClick={saveEmployee}
                  >
                    {editingEmployeeId
                      ? "Personeli Güncelle"
                      : "Personeli Kaydet"}
                  </button>
                </div>
              </section>

              <section className="panel payroll-payment-panel">
                <SectionTitle
                  eyebrow="ÖDEME OLUŞTUR"
                  title={tx(
                    "salaryPayment"
                  )}
                  description="Brüt ücret, prim ve kesinti üzerinden net ödemeyi kasaya gider olarak işleyin."
                />

                <div className="form-grid two-col">
                  <Field
                    label="Personel"
                    required
                    className="span-2"
                  >
                    <select
                      value={
                        payrollForm.employee_id
                      }
                      onChange={(event) =>
                        selectPayrollEmployee(
                          event.target.value
                        )
                      }
                    >
                      <option value="">
                        Personel seçin
                      </option>

                      {employees
                        .filter(
                          (employee) =>
                            employee.active
                        )
                        .map((employee) => (
                          <option
                            key={employee.id}
                            value={employee.id}
                          >
                            {employee.name} ·{" "}
                            {employee.role ||
                              "Görev belirtilmedi"}
                          </option>
                        ))}
                    </select>
                  </Field>

                  <Field
                    label="Maaş Dönemi"
                    required
                  >
                    <input
                      type="month"
                      value={
                        payrollForm.period
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            period:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field
                    label="Ödeme Tarihi"
                    required
                  >
                    <input
                      type="date"
                      value={
                        payrollForm.payment_date
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            payment_date:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Brüt Ücret">
                    <input
                      type="number"
                      min="0"
                      value={
                        payrollForm.gross
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            gross:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Prim / Ek Ödeme">
                    <input
                      type="number"
                      min="0"
                      value={
                        payrollForm.bonus
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            bonus:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Kesinti">
                    <input
                      type="number"
                      min="0"
                      value={
                        payrollForm.deduction
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            deduction:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Ödeme Yöntemi">
                    <select
                      value={
                        payrollForm.payment_method
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            payment_method:
                              event.target
                                .value,
                          })
                        )
                      }
                    >
                      {Object.keys(
                        PAYMENT_LABELS
                      ).map((payment) => (
                        <option
                          key={payment}
                          value={payment}
                        >
                          {label(
                            PAYMENT_LABELS,
                            payment
                          )}
                        </option>
                      ))}
                    </select>
                  </Field>

                  <Field label="Para Birimi">
                    <select
                      value={
                        payrollForm.currency
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            currency:
                              event.target
                                .value,
                          })
                        )
                      }
                    >
                      {currencies.map(
                        (currency) => (
                          <option
                            key={currency}
                          >
                            {currency}
                          </option>
                        )
                      )}
                    </select>
                  </Field>

                  <Field label="Ödeme Notu">
                    <input
                      value={
                        payrollForm.note
                      }
                      onChange={(event) =>
                        setPayrollForm(
                          (current) => ({
                            ...current,
                            note:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Bordro veya açıklama notu"
                    />
                  </Field>
                </div>

                <div className="payroll-total">
                  <span>
                    Ödenecek net tutar
                  </span>

                  <b>
                    {money(
                      payrollNet,
                      payrollForm.currency,
                      lang
                    )}
                  </b>

                  <small>
                    Brüt + Prim − Kesinti
                  </small>
                </div>

                <button
                  type="button"
                  className="btn primary full"
                  disabled={
                    saving ||
                    !employees.length
                  }
                  onClick={savePayroll}
                >
                  {saving
                    ? "Kaydediliyor..."
                    : "Maaş Ödemesini Kasaya Kaydet"}
                </button>
              </section>
            </div>

            <section className="panel">
              <SectionTitle
                eyebrow={`${employees.length} PERSONEL`}
                title={tx("staffCards")}
                description="Kayıtlı personeller ve temel ödeme bilgileri."
              />

              {employees.length ? (
                <div className="employee-cards">
                  {employees.map(
                    (employee) => (
                      <article
                        className="employee-card"
                        key={employee.id}
                      >
                        <div className="employee-avatar">
                          {String(
                            employee.name ||
                              "P"
                          )
                            .split(" ")
                            .slice(0, 2)
                            .map(
                              (word) =>
                                word[0]
                            )
                            .join("")
                            .toUpperCase()}
                        </div>

                        <div className="employee-main">
                          <h3>
                            {employee.name}
                          </h3>

                          <p>
                            {employee.role ||
                              "Görev belirtilmedi"}{" "}
                            ·{" "}
                            {employee.branch ||
                              "Şube belirtilmedi"}
                          </p>

                          <strong>
                            {money(
                              employee.base_salary,
                              employee.currency,
                              lang
                            )}{" "}
                            <small>
                              / ay
                            </small>
                          </strong>
                        </div>

                        <span
                          className={`status-badge ${
                            employee.active
                              ? "active"
                              : "passive"
                          }`}
                        >
                          {employee.active
                            ? "Aktif"
                            : "Pasif"}
                        </span>

                        <div className="employee-actions">
                          <button
                            type="button"
                            onClick={() =>
                              editEmployee(
                                employee
                              )
                            }
                          >
                            Düzenle
                          </button>

                          <button
                            type="button"
                            className="danger"
                            onClick={() =>
                              deleteEmployee(
                                employee.id
                              )
                            }
                          >
                            Sil
                          </button>
                        </div>
                      </article>
                    )
                  )}
                </div>
              ) : (
                <EmptyState text="Henüz personel kartı oluşturulmadı." />
              )}
            </section>

            <section className="panel">
              <SectionTitle
                eyebrow="KASA KAYITLARI"
                title={tx(
                  "salaryHistory"
                )}
                description="Seçili tarih aralığında personele yapılan maaş ve ücret ödemeleri."
                action={
                  <strong className="section-total">
                    {money(
                      totals.payroll,
                      filters.currency,
                      lang
                    )}
                  </strong>
                }
              />

              {renderRecordsTable(
                payrollRecords
              )}
            </section>
          </>
        )}

        {activeTab === "reports" && (
          <>
            <section className="panel report-control">
              <SectionTitle
                eyebrow="RAPOR OLUŞTURUCU"
                title={tx("reports")}
                description="Tarih, kaynak, kategori ve personel bazında filtreleyin; firma bilgilerinizle eksiksiz çıktı alın."
                action={
                  <div className="report-actions">
                    <button
                      type="button"
                      className="btn ghost compact"
                      onClick={exportCSV}
                    >
                      ⇩ CSV
                    </button>

                    <button
                      type="button"
                      className="btn primary compact"
                      onClick={
                        printCorporateReport
                      }
                    >
                      ▤ Yazdır / PDF
                    </button>
                  </div>
                }
              />

              <button
                type="button"
                className="mobile-filter-toggle"
                onClick={() =>
                  setMobileFilters(
                    (current) => !current
                  )
                }
              >
                ☰ {tx("filters")}
              </button>

              {renderFilters()}
            </section>

            <section className="metrics-grid report-metrics">
              <Metric
                icon="↗"
                tone="green"
                label={tx("income")}
                value={money(
                  totals.income,
                  filters.currency,
                  lang
                )}
                detail="Filtrelenen dönem"
              />

              <Metric
                icon="↘"
                tone="red"
                label={tx("expense")}
                value={money(
                  totals.expense,
                  filters.currency,
                  lang
                )}
                detail="Filtrelenen dönem"
              />

              <Metric
                icon="="
                tone={
                  net >= 0 ? "blue" : "red"
                }
                label={tx("net")}
                value={money(
                  net,
                  filters.currency,
                  lang
                )}
                detail={`${filteredRecords.length} toplam hareket`}
              />

              <Metric
                icon="₺"
                tone="violet"
                label={tx("payrollTotal")}
                value={money(
                  totals.payroll,
                  filters.currency,
                  lang
                )}
                detail={`${payrollRecords.length} ödeme`}
              />
            </section>

            <div className="report-columns">
              <section className="panel">
                <SectionTitle
                  eyebrow="PERSONEL MALİYETİ"
                  title={tx(
                    "payrollReport"
                  )}
                  description="Kime, kaç kez ve toplam ne kadar ödeme yapıldı?"
                />

                {payrollByStaff.length ? (
                  <div className="summary-list">
                    {payrollByStaff.map(
                      (item, index) => (
                        <div key={item.name}>
                          <span className="summary-index">
                            {String(
                              index + 1
                            ).padStart(
                              2,
                              "0"
                            )}
                          </span>

                          <span className="summary-name">
                            <b>
                              {item.name}
                            </b>

                            <small>
                              {item.count} ödeme
                              · Son:{" "}
                              {item.lastDate ||
                                "-"}
                            </small>
                          </span>

                          <strong>
                            {money(
                              item.total,
                              filters.currency,
                              lang
                            )}
                          </strong>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <EmptyState text="Seçili dönemde maaş ödemesi bulunmuyor." />
                )}
              </section>

              <section className="panel">
                <SectionTitle
                  eyebrow="FİNANS DAĞILIMI"
                  title={tx(
                    "categoryReport"
                  )}
                  description="Gelir ve giderlerin kategori bazlı toplamı."
                />

                {categorySummary.length ? (
                  <div className="summary-list category-list">
                    {categorySummary
                      .slice(0, 12)
                      .map((item) => (
                        <div
                          key={`${item.type}-${item.name}`}
                        >
                          <span
                            className={`summary-index ${item.type}`}
                          >
                            {item.type ===
                            "expense"
                              ? "−"
                              : "+"}
                          </span>

                          <span className="summary-name">
                            <b>
                              {item.name}
                            </b>

                            <small>
                              {item.count} işlem
                              ·{" "}
                              {item.type ===
                              "expense"
                                ? "Gider"
                                : "Gelir"}
                            </small>
                          </span>

                          <strong
                            className={
                              item.type ===
                              "expense"
                                ? "negative"
                                : "positive"
                            }
                          >
                            {money(
                              item.total,
                              filters.currency,
                              lang
                            )}
                          </strong>
                        </div>
                      ))}
                  </div>
                ) : (
                  <EmptyState text="Seçili dönemde rapor verisi bulunmuyor." />
                )}
              </section>
            </div>

            <section className="panel">
              <SectionTitle
                eyebrow={`${filteredRecords.length} KAYIT`}
                title={tx(
                  "transactionReport"
                )}
                description="Kurumsal rapora girecek tüm finans hareketleri."
              />

              {renderRecordsTable(
                filteredRecords
              )}
            </section>
          </>
        )}

        {activeTab === "company" && (
          <>
            <div className="draft-banner">
              <span>i</span>

              <div>
                <b>
                  Firma bilgileri taslak
                  alanıdır
                </b>

                <p>
                  {tx("frontendDraft")} Backend
                  tamamlandığında aynı alanlar
                  veritabanına bağlanabilir.
                </p>
              </div>
            </div>

            <div className="company-layout">
              <section className="panel company-form-panel">
                <SectionTitle
                  eyebrow="KURUMSAL KİMLİK"
                  title={tx(
                    "companyForm"
                  )}
                  description="Buradaki bilgiler yazdırılan/PDF raporların antetinde ve imza alanında kullanılır."
                />

                <div className="logo-upload-row">
                  <div className="company-logo-preview">
                    {company.logo ? (
                      <img
                        src={company.logo}
                        alt="Firma logosu"
                      />
                    ) : (
                      <span>
                        {(
                          company.legal_name ||
                          company.display_name ||
                          "FK"
                        )
                          .slice(0, 2)
                          .toUpperCase()}
                      </span>
                    )}
                  </div>

                  <div>
                    <b>Firma logosu</b>

                    <p>
                      PNG veya JPG, en fazla
                      700 KB.
                    </p>

                    <label className="upload-btn">
                      Logo Seç

                      <input
                        type="file"
                        accept="image/*"
                        onChange={
                          handleLogoFile
                        }
                      />
                    </label>

                    {company.logo && (
                      <button
                        type="button"
                        className="remove-logo"
                        onClick={() =>
                          setCompany(
                            (current) => ({
                              ...current,
                              logo: "",
                            })
                          )
                        }
                      >
                        Logoyu kaldır
                      </button>
                    )}
                  </div>
                </div>

                <div className="form-grid two-col">
                  <Field
                    label="Resmî / Ticari Unvan"
                    required
                    className="span-2"
                  >
                    <input
                      value={
                        company.legal_name
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            legal_name:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Örn. ABC Danışmanlık Ltd. Şti."
                    />
                  </Field>

                  <Field label="Görünen Kısa Ad">
                    <input
                      value={
                        company.display_name
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            display_name:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="ABC Danışmanlık"
                    />
                  </Field>

                  <Field label="Yetkili Kişi">
                    <input
                      value={
                        company.authorized_person
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            authorized_person:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Ad Soyad"
                    />
                  </Field>

                  <Field label="Vergi Dairesi">
                    <input
                      value={
                        company.tax_office
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            tax_office:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Vergi / Kimlik No">
                    <input
                      value={
                        company.tax_number
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            tax_number:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Ticaret / Dernek Sicil No">
                    <input
                      value={
                        company.registry_number
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            registry_number:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Varsayılan Para Birimi">
                    <select
                      value={
                        company.default_currency
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            default_currency:
                              event.target
                                .value,
                          })
                        )
                      }
                    >
                      {currencies.map(
                        (currency) => (
                          <option
                            key={currency}
                          >
                            {currency}
                          </option>
                        )
                      )}
                    </select>
                  </Field>

                  <Field label="Telefon">
                    <input
                      value={company.phone}
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            phone:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="E-posta">
                    <input
                      type="email"
                      value={company.email}
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            email:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field label="Web Sitesi">
                    <input
                      value={company.website}
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            website:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="www.firma.com"
                    />
                  </Field>

                  <Field
                    label="IBAN"
                    className="span-2"
                  >
                    <input
                      value={company.iban}
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            iban:
                              event.target.value.toUpperCase(),
                          })
                        )
                      }
                      placeholder="TR00 0000 0000 0000 0000 0000 00"
                    />
                  </Field>

                  <Field
                    label="Adres"
                    className="span-2"
                  >
                    <textarea
                      rows="3"
                      value={company.address}
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            address:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>

                  <Field
                    label="Rapor Alt Notu"
                    className="span-2"
                  >
                    <textarea
                      rows="3"
                      value={
                        company.report_note
                      }
                      onChange={(event) =>
                        setCompany(
                          (current) => ({
                            ...current,
                            report_note:
                              event.target
                                .value,
                          })
                        )
                      }
                    />
                  </Field>
                </div>

                <div className="form-actions end">
                  <button
                    type="button"
                    className="btn primary"
                    onClick={
                      saveCompanyDraft
                    }
                  >
                    {tx("saveDraft")}
                  </button>
                </div>
              </section>

              <aside className="panel company-preview-panel">
                <SectionTitle
                  eyebrow="CANLI ÖNİZLEME"
                  title={tx(
                    "companyPreview"
                  )}
                  description="Kurumsal raporun üst ve alt alanlarının yaklaşık görünümü."
                />

                <div className="report-paper">
                  <div className="paper-header">
                    <div className="paper-brand">
                      {company.logo ? (
                        <img
                          src={company.logo}
                          alt=""
                        />
                      ) : (
                        <span>
                          {(
                            company.legal_name ||
                            company.display_name ||
                            "FK"
                          )
                            .slice(0, 2)
                            .toUpperCase()}
                        </span>
                      )}

                      <div>
                        <b>
                          {company.legal_name ||
                            company.display_name ||
                            "Kurum / Firma Adı"}
                        </b>

                        <small>
                          {company.address ||
                            "Firma adresi"}
                        </small>

                        <small>
                          {[company.phone, company.email]
                            .filter(Boolean)
                            .join(" · ") ||
                            "Telefon · E-posta"}
                        </small>
                      </div>
                    </div>

                    <div className="paper-tax">
                      <span>
                        Vergi Dairesi:{" "}
                        <b>
                          {company.tax_office ||
                            "-"}
                        </b>
                      </span>

                      <span>
                        Vergi No:{" "}
                        <b>
                          {company.tax_number ||
                            "-"}
                        </b>
                      </span>

                      <span>
                        Sicil No:{" "}
                        <b>
                          {company.registry_number ||
                            "-"}
                        </b>
                      </span>
                    </div>
                  </div>

                  <h3>
                    KURUMSAL GELİR–GİDER
                    RAPORU
                  </h3>

                  <div className="paper-lines">
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                  </div>

                  <div className="paper-footer">
                    <span>
                      <b>IBAN</b>
                      {company.iban || "-"}
                    </span>

                    <span>
                      <b>Yetkili / İmza</b>
                      {company.authorized_person ||
                        "-"}
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  className="btn primary full"
                  onClick={
                    printCorporateReport
                  }
                >
                  ▤ Örnek Kurumsal Raporu
                  Aç
                </button>
              </aside>
            </div>
          </>
        )}

        {activeTab === "training" && (
          <section className="panel training-panel">
            <SectionTitle
              eyebrow="KULLANIM REHBERİ"
              title={tx("training")}
              description={tx(
                "trainingIntro"
              )}
            />

            <div className="training-progress">
              <div>
                <span>TEMEL EĞİTİM</span>
                <b>7 uygulamalı konu</b>
              </div>

              <i>
                <em
                  style={{
                    width: `${
                      ((openTraining + 1) /
                        TRAINING_ITEMS.length) *
                      100
                    }%`,
                  }}
                />
              </i>
            </div>

            <div className="training-list">
              {TRAINING_ITEMS.map(
                (item, index) => (
                  <article
                    key={item.title}
                    className={
                      openTraining === index
                        ? "open"
                        : ""
                    }
                  >
                    <button
                      type="button"
                      onClick={() =>
                        setOpenTraining(
                          openTraining ===
                            index
                            ? -1
                            : index
                        )
                      }
                    >
                      <span className="lesson-number">
                        {String(
                          index + 1
                        ).padStart(2, "0")}
                      </span>

                      <span>
                        <b>
                          {item.title.replace(
                            /^\d+\.\s*/,
                            ""
                          )}
                        </b>

                        <small>
                          {item.text}
                        </small>
                      </span>

                      <em>
                        {openTraining === index
                          ? "−"
                          : "+"}
                      </em>
                    </button>

                    {openTraining === index && (
                      <div className="lesson-content">
                        <p>{item.text}</p>

                        <ol>
                          {item.steps.map(
                            (step) => (
                              <li key={step}>
                                {step}
                              </li>
                            )
                          )}
                        </ol>

                        {index === 5 && (
                          <button
                            type="button"
                            className="btn primary compact"
                            onClick={() =>
                              setActiveTab(
                                "reports"
                              )
                            }
                          >
                            Raporlar bölümünü
                            aç
                          </button>
                        )}
                      </div>
                    )}
                  </article>
                )
              )}
            </div>

            <div className="support-card">
              <div className="support-icon">
                ?
              </div>

              <div>
                <b>
                  Hızlı kullanım özeti
                </b>

                <p>
                  Önce firma bilgilerini ve
                  personel kartlarını
                  oluşturun. Günlük
                  gelir–giderleri doğru
                  kategoride kaydedin. Ay
                  sonunda Kurumsal Raporlar
                  bölümünden dönemi seçip
                  PDF çıktınızı alın.
                </p>
              </div>
            </div>
          </section>
        )}
      </main>

      <style>{FINANCE_STYLES}</style>
    </div>
  );
}

function Field({
  label,
  required = false,
  className = "",
  children,
}) {
  return (
    <label className={`field ${className}`}>
      <span>
        {label}
        {required && <em>*</em>}
      </span>

      {children}
    </label>
  );
}

function Metric({
  icon,
  tone,
  label,
  value,
  detail,
}) {
  return (
    <article className={`metric-card ${tone}`}>
      <span className="metric-icon">
        {icon}
      </span>

      <div>
        <small>{label}</small>
        <strong>{value}</strong>
        <p>{detail}</p>
      </div>
    </article>
  );
}

function SectionTitle({
  eyebrow,
  title,
  description,
  action = null,
}) {
  return (
    <div className="section-heading">
      <div>
        <span>{eyebrow}</span>
        <h2>{title}</h2>

        {description && (
          <p>{description}</p>
        )}
      </div>

      {action && (
        <div className="section-action">
          {action}
        </div>
      )}
    </div>
  );
}

function EmptyState({ text }) {
  return (
    <div className="empty-state">
      <span>∅</span>
      <b>Kayıt bulunamadı</b>
      <p>{text}</p>
    </div>
  );
}

const FINANCE_STYLES = `
  :root {
    --fin-navy: #0b2744;
    --fin-blue: #0d4f8b;
    --fin-blue-2: #176baa;
    --fin-orange: #ef7b23;
    --fin-ink: #172b40;
    --fin-muted: #6a7b8e;
    --fin-line: #dfe7ef;
    --fin-bg: #f3f6f9;
    --fin-green: #178354;
    --fin-red: #c84a4a;
    --fin-violet: #7454b8;
    --fin-white: #ffffff;
    --fin-shadow: 0 10px 30px rgba(22, 47, 72, 0.07);
    --fin-radius: 18px;
  }

  .finance-app {
    min-height: 100vh;
    padding-bottom: 50px;
    background: var(--fin-bg);
    color: var(--fin-ink);
    font-family:
      Inter,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
  }

  .finance-app * {
    box-sizing: border-box;
  }

  .finance-app button,
  .finance-app input,
  .finance-app select,
  .finance-app textarea {
    font: inherit;
  }

  .finance-hero {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 30px;
    padding:
      40px
      clamp(22px, 4vw, 64px)
      34px;
    overflow: hidden;
    color: #ffffff;
    background:
      linear-gradient(
        118deg,
        #071f37 0%,
        #0a3f70 57%,
        #0e5e9c 100%
      );
  }

  .finance-hero::before {
    content: "";
    position: absolute;
    top: -210px;
    right: -100px;
    width: 600px;
    height: 600px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    box-shadow:
      0 0 0 80px rgba(255, 255, 255, 0.02),
      0 0 0 160px rgba(255, 255, 255, 0.02);
  }

  .hero-copy,
  .hero-actions {
    position: relative;
    z-index: 1;
  }

  .hero-copy {
    max-width: 750px;
  }

  .hero-eyebrow {
    display: flex;
    align-items: center;
    gap: 9px;
    margin-bottom: 12px;
    color: #bcd9ee;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 1.7px;
  }

  .hero-eyebrow i {
    width: 22px;
    height: 2px;
    background: var(--fin-orange);
  }

  .hero-copy h1 {
    margin: 0 0 9px;
    font-size: clamp(26px, 3vw, 41px);
    font-weight: 760;
    letter-spacing: -1.2px;
  }

  .hero-copy > p {
    max-width: 700px;
    margin: 0;
    color: #c6d8e8;
    font-size: 14px;
    line-height: 1.65;
  }

  .hero-status {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
    margin-top: 20px;
    color: #c8d8e6;
    font-size: 11px;
  }

  .hero-status span {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  .hero-status span + span::before {
    content: "";
    width: 3px;
    height: 3px;
    margin-right: 10px;
    border-radius: 50%;
    background: #7da4c4;
  }

  .hero-status .online {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #42d191;
    box-shadow:
      0 0 0 4px
      rgba(66, 209, 145, 0.16);
  }

  .hero-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    max-width: 560px;
  }

  .hero-btn {
    height: 42px;
    padding: 0 14px;
    border:
      1px solid
      rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.2s;
  }

  .hero-btn.secondary {
    background:
      rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(8px);
  }

  .hero-btn.primary {
    border-color: var(--fin-orange);
    background: var(--fin-orange);
  }

  .hero-btn:hover {
    transform: translateY(-1px);
    filter: brightness(1.06);
  }

  .finance-tabs {
    display: grid;
    grid-template-columns:
      repeat(6, 1fr);
    padding:
      0
      clamp(18px, 4vw, 64px);
    border-bottom:
      1px solid var(--fin-line);
    background: #ffffff;
    box-shadow:
      0 4px 18px
      rgba(24, 52, 78, 0.04);
  }

  .finance-tabs button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    min-height: 62px;
    border: 0;
    background: transparent;
    color: #607286;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    cursor: pointer;
  }

  .finance-tabs button span {
    color: #a7b4c1;
    font-size: 9px;
    font-weight: 900;
  }

  .finance-tabs button::after {
    content: "";
    position: absolute;
    right: 22%;
    bottom: 0;
    left: 22%;
    height: 3px;
    border-radius: 5px 5px 0 0;
    background: transparent;
  }

  .finance-tabs button.active {
    color: var(--fin-blue);
  }

  .finance-tabs button.active span {
    color: var(--fin-orange);
  }

  .finance-tabs button.active::after {
    background: var(--fin-orange);
  }

  .context-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    max-width: 1540px;
    margin: 0 auto;
    padding:
      20px
      clamp(18px, 4vw, 48px)
      0;
  }

  .period-pills {
    display: flex;
    gap: 5px;
    padding: 4px;
    border-radius: 10px;
    background: #e8eef4;
  }

  .period-pills button {
    height: 31px;
    padding: 0 13px;
    border: 0;
    border-radius: 7px;
    background: transparent;
    color: #65768a;
    font-size: 10px;
    font-weight: 750;
    cursor: pointer;
  }

  .period-pills button.active {
    background: #ffffff;
    color: var(--fin-blue);
    box-shadow:
      0 2px 8px
      rgba(19, 47, 72, 0.08);
  }

  .currency-select {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .currency-select span {
    color: #718196;
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.7px;
  }

  .currency-select select {
    height: 37px;
    padding: 0 30px 0 12px;
    border: 1px solid var(--fin-line);
    border-radius: 9px;
    outline: none;
    background: #ffffff;
    color: var(--fin-ink);
    font-size: 12px;
    font-weight: 800;
  }

  .finance-main {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 1540px;
    margin: 0 auto;
    padding:
      20px
      clamp(18px, 4vw, 48px);
  }

  .panel {
    padding: 24px;
    border: 1px solid #e2e9f0;
    border-radius: var(--fin-radius);
    background: #ffffff;
    box-shadow: var(--fin-shadow);
  }

  .section-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 22px;
  }

  .section-heading > div:first-child {
    min-width: 0;
  }

  .section-heading span {
    display: block;
    margin-bottom: 5px;
    color: var(--fin-orange);
    font-size: 9px;
    font-weight: 900;
    letter-spacing: 1.25px;
  }

  .section-heading h2 {
    margin: 0;
    color: var(--fin-navy);
    font-size: 19px;
    line-height: 1.25;
    letter-spacing: -0.25px;
  }

  .section-heading p {
    margin: 7px 0 0;
    color: var(--fin-muted);
    font-size: 11px;
    line-height: 1.55;
  }

  .section-action {
    flex: none;
  }

  .text-btn {
    border: 0;
    background: transparent;
    color: var(--fin-blue);
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
  }

  .metrics-grid {
    display: grid;
    grid-template-columns:
      repeat(4, 1fr);
    gap: 14px;
  }

  .metric-card {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 14px;
    min-height: 136px;
    padding: 22px;
    overflow: hidden;
    border: 1px solid #e2e9f0;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: var(--fin-shadow);
  }

  .metric-card::after {
    content: "";
    position: absolute;
    right: -20px;
    bottom: -40px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: currentColor;
    opacity: 0.045;
  }

  .metric-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 42px;
    height: 42px;
    border-radius: 12px;
    background: #eaf1f6;
    color: inherit;
    font-size: 20px;
    font-weight: 700;
  }

  .metric-card > div {
    min-width: 0;
  }

  .metric-card small {
    display: block;
    margin-bottom: 7px;
    color: #718296;
    font-size: 9px;
    font-weight: 850;
    text-transform: uppercase;
    letter-spacing: 0.65px;
  }

  .metric-card strong {
    display: block;
    color: var(--fin-ink);
    font-size:
      clamp(18px, 1.7vw, 27px);
    line-height: 1.1;
    white-space: nowrap;
    letter-spacing: -0.5px;
  }

  .metric-card p {
    margin: 10px 0 0;
    color: #8493a3;
    font-size: 10px;
  }

  .metric-card.green {
    color: var(--fin-green);
  }

  .metric-card.red {
    color: var(--fin-red);
  }

  .metric-card.blue {
    color: var(--fin-blue);
  }

  .metric-card.violet {
    color: var(--fin-violet);
  }

  .quick-grid {
    display: grid;
    grid-template-columns:
      repeat(4, 1fr);
    gap: 10px;
  }

  .quick-grid button {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 78px;
    padding: 13px;
    border: 1px solid var(--fin-line);
    border-radius: 13px;
    background: #fbfcfd;
    text-align: left;
    cursor: pointer;
    transition: 0.18s;
  }

  .quick-grid button:hover {
    transform: translateY(-2px);
    border-color: #bed1e1;
    background: #ffffff;
    box-shadow:
      0 8px 18px
      rgba(17, 55, 87, 0.08);
  }

  .quick-grid button > span:nth-child(2) {
    min-width: 0;
    flex: 1;
  }

  .quick-grid button b,
  .quick-grid button small {
    display: block;
  }

  .quick-grid button b {
    color: var(--fin-ink);
    font-size: 12px;
  }

  .quick-grid button small {
    margin-top: 4px;
    overflow: hidden;
    color: #7a899a;
    font-size: 9px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .quick-grid button em {
    color: #9aabba;
    font-size: 20px;
    font-style: normal;
  }

  .quick-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    height: 40px;
    border-radius: 11px;
    color: #ffffff;
    font-size: 11px;
    font-weight: 900;
  }

  .quick-icon.blue {
    background: #2a70ad;
  }

  .quick-icon.cyan {
    background: #218fa0;
  }

  .quick-icon.violet {
    background: #7d5cb8;
  }

  .quick-icon.orange {
    background: #e98931;
  }

  .quick-icon.red {
    background: #d75959;
  }

  .quick-icon.slate {
    background: #526d86;
  }

  .quick-icon.rose {
    background: #bd5c80;
  }

  .quick-icon.amber {
    background: #b8832b;
  }

  .overview-columns {
    display: grid;
    grid-template-columns:
      minmax(0, 2fr)
      minmax(260px, 0.72fr);
    gap: 20px;
  }

  .expense-row {
    display: flex;
    align-items: center;
    gap: 13px;
    padding: 11px 0;
    border-bottom: 1px solid #edf1f5;
  }

  .expense-row:last-child {
    border-bottom: 0;
  }

  .rank {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 31px;
    height: 31px;
    border-radius: 8px;
    background: #edf3f8;
    color: #718498;
    font-size: 9px;
    font-weight: 900;
  }

  .expense-info {
    min-width: 0;
    flex: 1;
  }

  .expense-info > div {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 7px;
  }

  .expense-info b {
    font-size: 11px;
  }

  .expense-info span {
    color: #8190a0;
    font-size: 9px;
  }

  .expense-info > i {
    display: block;
    height: 5px;
    overflow: hidden;
    border-radius: 10px;
    background: #e9eef3;
  }

  .expense-info > i em {
    display: block;
    height: 100%;
    border-radius: 10px;
    background:
      linear-gradient(
        90deg,
        #0e5897,
        #2b8fc4
      );
  }

  .expense-row > strong {
    min-width: 120px;
    color: var(--fin-red);
    font-size: 11px;
    text-align: right;
  }

  .health-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background:
      linear-gradient(
        155deg,
        #092d50,
        #0c568e
      );
    color: #ffffff;
    text-align: center;
  }

  .health-score {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 90px;
    margin-bottom: 13px;
    border:
      8px solid
      rgba(255, 255, 255, 0.12);
    border-top-color: #3ed397;
    border-radius: 50%;
    font-size: 25px;
    font-weight: 800;
  }

  .health-card small {
    color: #9dc2df;
    font-size: 8px;
    font-weight: 900;
    letter-spacing: 1.1px;
  }

  .health-card h3 {
    margin: 8px 0 5px;
    font-size: 17px;
  }

  .health-card p {
    max-width: 250px;
    margin: 0;
    color: #bcd1e1;
    font-size: 10px;
    line-height: 1.55;
  }

  .health-card button {
    margin-top: 17px;
    border: 0;
    background: transparent;
    color: #ffffff;
    font-size: 10px;
    font-weight: 800;
    cursor: pointer;
  }

  .records-wrap {
    min-width: 0;
  }

  .records-count {
    margin: -4px 0 11px;
    color: #8291a0;
    font-size: 9px;
  }

  .records-count b {
    color: var(--fin-blue);
  }

  .table-scroll {
    overflow-x: auto;
  }

  .finance-table {
    width: 100%;
    min-width: 900px;
    border-collapse: collapse;
  }

  .finance-table th {
    padding: 10px 11px;
    border-bottom: 1px solid #dfe7ef;
    color: #8291a0;
    font-size: 8px;
    font-weight: 900;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  }

  .finance-table td {
    padding: 12px 11px;
    border-bottom: 1px solid #edf1f4;
    color: #536477;
    font-size: 10px;
    vertical-align: middle;
  }

  .finance-table tbody tr:hover {
    background: #f8fafc;
  }

  .finance-table tbody tr:last-child td {
    border-bottom: 0;
  }

  .right {
    text-align: right !important;
  }

  .date-cell {
    color: #728396 !important;
    white-space: nowrap;
  }

  .transaction-name {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 180px;
  }

  .type-dot {
    flex: 0 0 7px;
    height: 7px;
    border-radius: 50%;
  }

  .type-dot.income {
    background: var(--fin-green);
    box-shadow:
      0 0 0 4px
      rgba(23, 131, 84, 0.1);
  }

  .type-dot.expense {
    background: var(--fin-red);
    box-shadow:
      0 0 0 4px
      rgba(200, 74, 74, 0.1);
  }

  .transaction-name b,
  .transaction-name small {
    display: block;
  }

  .transaction-name b {
    max-width: 280px;
    overflow: hidden;
    color: var(--fin-ink);
    font-size: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .transaction-name small,
  .subtext {
    margin-top: 3px;
    color: #8a98a7;
    font-size: 8px;
  }

  .source-badge {
    display: inline-flex;
    padding: 5px 8px;
    border-radius: 7px;
    background: #edf3f8;
    color: #315b7d;
    font-size: 8px;
    font-weight: 800;
    white-space: nowrap;
  }

  .related-name {
    display: block;
    color: #526477;
    font-size: 9px;
  }

  .amount-cell {
    font-size: 11px !important;
    font-weight: 850;
    white-space: nowrap;
  }

  .positive {
    color: var(--fin-green) !important;
  }

  .negative {
    color: var(--fin-red) !important;
  }

  .row-actions {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
  }

  .row-actions button,
  .employee-actions button {
    padding: 5px 7px;
    border: 1px solid #dce5ed;
    border-radius: 6px;
    background: #ffffff;
    color: var(--fin-blue);
    font-size: 8px;
    font-weight: 800;
    cursor: pointer;
  }

  .row-actions button.danger,
  .employee-actions button.danger {
    color: var(--fin-red);
  }

  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 42px;
    padding: 0 18px;
    border: 1px solid transparent;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
    transition: 0.18s;
  }

  .btn.primary {
    background: var(--fin-blue);
    color: #ffffff;
  }

  .btn.primary:hover {
    background: #083e70;
  }

  .btn.ghost {
    border-color: #d9e3eb;
    background: #ffffff;
    color: #526579;
  }

  .btn.compact {
    min-height: 36px;
    padding: 0 13px;
    font-size: 10px;
  }

  .btn.full {
    width: 100%;
  }

  .btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  .form-actions {
    display: flex;
    gap: 8px;
  }

  .form-actions.end {
    justify-content: flex-end;
    margin-top: 20px;
  }

  .finance-filters {
    display: grid;
    grid-template-columns:
      1.4fr repeat(4, 1fr);
    gap: 10px;
    padding: 15px;
    border: 1px solid #e1e9f0;
    border-radius: 13px;
    background: #f8fafc;
  }

  .filter-wide {
    grid-column: span 2;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .field > span {
    color: #65768a;
    font-size: 8px;
    font-weight: 850;
    text-transform: uppercase;
    letter-spacing: 0.45px;
  }

  .field > span em {
    margin-left: 3px;
    color: var(--fin-red);
    font-style: normal;
  }

  .field input,
  .field select,
  .field textarea {
    width: 100%;
    border: 1px solid #d9e3eb;
    border-radius: 9px;
    outline: none;
    background: #ffffff;
    color: #263b50;
    transition: 0.16s;
  }

  .field input,
  .field select {
    height: 40px;
    padding: 0 11px;
  }

  .field textarea {
    padding: 10px 11px;
    resize: vertical;
  }

  .field input::placeholder,
  .field textarea::placeholder {
    color: #a0adba;
  }

  .field input:focus,
  .field select:focus,
  .field textarea:focus {
    border-color: #4d8dbd;
    box-shadow:
      0 0 0 3px
      rgba(31, 103, 158, 0.09);
  }

  .filter-clear {
    align-self: end;
    height: 40px;
    border: 1px solid #d9e3eb;
    border-radius: 9px;
    background: #ffffff;
    color: #65788b;
    font-size: 9px;
    font-weight: 800;
    cursor: pointer;
  }

  .mobile-filter-toggle {
    display: none;
    width: 100%;
    height: 40px;
    border: 1px solid #dce5ed;
    border-radius: 9px;
    background: #f8fafc;
    color: var(--fin-blue);
    font-size: 10px;
    font-weight: 800;
  }

  .form-panel {
    border-top:
      4px solid var(--fin-orange);
    scroll-margin-top: 20px;
  }

  .type-switch {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    max-width: 500px;
    margin-bottom: 20px;
    padding: 5px;
    border-radius: 11px;
    background: #edf2f6;
  }

  .type-switch button {
    height: 40px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #657689;
    font-size: 11px;
    font-weight: 800;
    cursor: pointer;
  }

  .type-switch button span {
    margin-right: 5px;
  }

  .type-switch button.active {
    background: #ffffff;
    box-shadow:
      0 3px 9px
      rgba(29, 55, 80, 0.09);
  }

  .type-switch button.active.income {
    color: var(--fin-green);
  }

  .type-switch button.active.expense {
    color: var(--fin-red);
  }

  .form-grid {
    display: grid;
    gap: 14px;
  }

  .transaction-grid {
    grid-template-columns:
      repeat(4, 1fr);
  }

  .two-col {
    grid-template-columns:
      repeat(2, 1fr);
  }

    .span-2 {
    grid-column: span 2;
  }

  .customer-picker {
    position: relative;
  }

  .customer-search-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
  }

  .customer-clear {
    min-width: 108px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #d7e1ea;
    border-radius: 9px;
    background: #f7f9fb;
    color: #52697d;
    font-size: 9px;
    font-weight: 850;
    cursor: pointer;
  }

  .customer-results {
    position: absolute;
    z-index: 40;
    top: 46px;
    right: 0;
    left: 0;
    overflow: hidden;
    border: 1px solid #d8e3ec;
    border-radius: 11px;
    background: #ffffff;
    box-shadow: 0 16px 35px rgba(28, 55, 78, 0.16);
  }

  .customer-results button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    min-height: 48px;
    padding: 9px 12px;
    border: 0;
    border-bottom: 1px solid #edf1f4;
    background: #ffffff;
    color: #253b50;
    text-align: left;
    cursor: pointer;
  }

  .customer-results button:last-child {
    border-bottom: 0;
  }

  .customer-results button:hover {
    background: #f2f7fb;
  }

  .customer-results strong,
  .customer-results span {
    display: block;
  }

  .customer-results strong {
    font-size: 11px;
  }

  .customer-results span {
    color: #75879a;
    font-size: 9px;
  }

  .selected-customer {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 3px 10px;
    margin-top: 8px;
    padding: 10px 12px;
    border: 1px solid #cfe6d9;
    border-radius: 10px;
    background: #f0faf4;
  }

  .selected-customer span {
    color: #188253;
    font-size: 8px;
    font-weight: 900;
    text-transform: uppercase;
  }

  .selected-customer strong {
    color: #244335;
    font-size: 11px;
  }

  .selected-customer small {
    grid-column: 1 / -1;
    color: #688175;
    font-size: 9px;
  }

  .form-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-top: 20px;
    padding: 15px 17px;
    border-radius: 12px;
    background: #edf4f9;
  }

  .form-summary > div:first-child span,



  .form-summary > div:first-child b {
    display: block;
  }

  .form-summary > div:first-child span {
    color: #6e8093;
    font-size: 9px;
    font-weight: 800;
    text-transform: uppercase;
  }

  .form-summary > div:first-child b {
    margin-top: 4px;
    color: var(--fin-blue);
    font-size: 20px;
  }

  .draft-banner {
    display: flex;
    align-items: center;
    gap: 13px;
    padding: 14px 17px;
    border: 1px solid #cfe0ed;
    border-radius: 13px;
    background: #eaf4fb;
  }

  .draft-banner > span {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 30px;
    height: 30px;
    border-radius: 50%;
    background: var(--fin-blue);
    color: #ffffff;
    font-family: serif;
    font-weight: 800;
  }

  .draft-banner b {
    display: block;
    color: #214d70;
    font-size: 11px;
  }

  .draft-banner p {
    margin: 3px 0 0;
    color: #5f7d94;
    font-size: 9px;
    line-height: 1.5;
  }

  .payroll-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .checkbox-field {
    display: flex;
    align-items: center;
    gap: 9px;
    color: #526578;
    font-size: 10px;
  }

  .checkbox-field input {
    accent-color: var(--fin-blue);
  }

  .payroll-total {
    margin: 20px 0 12px;
    padding: 16px;
    border: 1px solid #d7e4ee;
    border-radius: 12px;
    background:
      linear-gradient(
        135deg,
        #f1f7fb,
        #e9f2f8
      );
    text-align: center;
  }

  .payroll-total span,
  .payroll-total b,
  .payroll-total small {
    display: block;
  }

  .payroll-total span {
    color: #718599;
    font-size: 9px;
    font-weight: 850;
    text-transform: uppercase;
  }

  .payroll-total b {
    margin: 4px 0;
    color: var(--fin-blue);
    font-size: 24px;
  }

  .payroll-total small {
    color: #91a0ae;
    font-size: 8px;
  }

  .employee-cards {
    display: grid;
    grid-template-columns:
      repeat(3, 1fr);
    gap: 11px;
  }

  .employee-card {
    position: relative;
    display: grid;
    grid-template-columns:
      auto 1fr auto;
    align-items: center;
    gap: 12px;
    padding: 15px;
    border: 1px solid var(--fin-line);
    border-radius: 13px;
    background: #fbfcfd;
  }

  .employee-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 43px;
    height: 43px;
    border-radius: 12px;
    background: #dfeef9;
    color: var(--fin-blue);
    font-size: 12px;
    font-weight: 900;
  }

  .employee-main {
    min-width: 0;
  }

  .employee-main h3 {
    margin: 0;
    color: var(--fin-ink);
    font-size: 12px;
  }

  .employee-main p {
    margin: 4px 0;
    overflow: hidden;
    color: #7a8999;
    font-size: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .employee-main strong {
    color: var(--fin-blue);
    font-size: 11px;
  }

  .employee-main strong small {
    font-size: 8px;
    font-weight: 500;
  }

  .status-badge {
    position: absolute;
    top: 11px;
    right: 12px;
    padding: 4px 7px;
    border-radius: 10px;
    font-size: 7px;
    font-weight: 900;
  }

  .status-badge.active {
    background: #def4e9;
    color: #18734c;
  }

  .status-badge.passive {
    background: #f1e7e7;
    color: #995555;
  }

  .employee-actions {
    grid-column: 2 / 4;
    display: flex;
    gap: 5px;
  }

  .section-total {
    color: var(--fin-violet);
    font-size: 16px;
  }

  .report-actions {
    display: flex;
    gap: 7px;
  }

  .report-columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .summary-list > div {
    display: flex;
    align-items: center;
    gap: 11px;
    padding: 11px 0;
    border-bottom: 1px solid #edf1f4;
  }

  .summary-list > div:last-child {
    border-bottom: 0;
  }

  .summary-index {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 31px;
    height: 31px;
    border-radius: 8px;
    background: #eaf2f8;
    color: var(--fin-blue);
    font-size: 9px;
    font-weight: 900;
  }

  .summary-index.income {
    background: #e4f4ec;
    color: var(--fin-green);
  }

  .summary-index.expense {
    background: #f9e8e8;
    color: var(--fin-red);
  }

  .summary-name {
    min-width: 0;
    flex: 1;
  }

  .summary-name b,
  .summary-name small {
    display: block;
  }

  .summary-name b {
    overflow: hidden;
    font-size: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .summary-name small {
    margin-top: 3px;
    color: #8291a0;
    font-size: 8px;
  }

  .summary-list strong {
    font-size: 10px;
    white-space: nowrap;
  }

  .company-layout {
    display: grid;
    grid-template-columns:
      minmax(0, 1.15fr)
      minmax(370px, 0.85fr);
    align-items: start;
    gap: 20px;
  }

  .company-preview-panel {
    position: sticky;
    top: 18px;
  }

  .logo-upload-row {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid var(--fin-line);
    border-radius: 13px;
    background: #f8fafc;
  }

  .company-logo-preview {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 74px;
    height: 74px;
    overflow: hidden;
    border: 1px dashed #b7c8d6;
    border-radius: 14px;
    background: #ffffff;
    color: var(--fin-blue);
    font-size: 19px;
    font-weight: 900;
  }

  .company-logo-preview img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .logo-upload-row b {
    font-size: 11px;
  }

  .logo-upload-row p {
    margin: 4px 0 8px;
    color: #8392a1;
    font-size: 8px;
  }

  .upload-btn {
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 0 10px;
    border-radius: 7px;
    background: var(--fin-blue);
    color: #ffffff;
    font-size: 8px;
    font-weight: 800;
    cursor: pointer;
  }

  .upload-btn input {
    display: none;
  }

  .remove-logo {
    margin-left: 7px;
    border: 0;
    background: transparent;
    color: var(--fin-red);
    font-size: 8px;
    font-weight: 700;
    cursor: pointer;
  }

  .report-paper {
    min-height: 450px;
    margin-bottom: 13px;
    padding: 22px;
    border: 1px solid #dbe3e9;
    background: #ffffff;
    box-shadow:
      0 7px 22px
      rgba(25, 51, 73, 0.11);
  }

  .paper-header {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding-bottom: 13px;
    border-bottom:
      3px solid var(--fin-blue);
  }

  .paper-brand {
    display: flex;
    align-items: center;
    gap: 9px;
    max-width: 62%;
  }

  .paper-brand > img,
  .paper-brand > span {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 42px;
    width: 42px;
    height: 42px;
    border: 1px solid #dfe7ed;
    border-radius: 7px;
    color: var(--fin-blue);
    font-size: 10px;
    font-weight: 900;
    object-fit: contain;
  }

  .paper-brand div {
    min-width: 0;
  }

  .paper-brand b,
  .paper-brand small {
    display: block;
  }

  .paper-brand b {
    overflow: hidden;
    font-size: 9px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .paper-brand small {
    margin-top: 3px;
    overflow: hidden;
    color: #7a8895;
    font-size: 5px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .paper-tax {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    gap: 3px;
    color: #73818e;
    font-size: 5px;
  }

  .report-paper > h3 {
    margin: 18px 0;
    color: var(--fin-navy);
    font-size: 11px;
  }

  .paper-lines {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 15px 0;
  }

  .paper-lines i {
    height: 8px;
    border-radius: 3px;
    background:
      linear-gradient(
        90deg,
        #edf1f4 0 32%,
        #f6f8fa 32% 54%,
        #edf1f4 54% 100%
      );
  }

  .paper-footer {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-top: 55px;
    padding-top: 12px;
    border-top: 1px solid #dfe6ec;
    color: #778592;
    font-size: 6px;
  }

  .paper-footer span {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .paper-footer span:last-child {
    min-width: 100px;
    border-bottom: 1px solid #84919c;
    text-align: center;
  }

  .paper-footer b {
    color: #455666;
    font-size: 6px;
  }

  .training-panel {
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;
  }

  .training-progress {
    display: flex;
    align-items: center;
    gap: 25px;
    margin-bottom: 18px;
    padding: 15px;
    border-radius: 12px;
    background: #eef4f8;
  }

  .training-progress > div {
    min-width: 145px;
  }

  .training-progress span,
  .training-progress b {
    display: block;
  }

  .training-progress span {
    color: var(--fin-orange);
    font-size: 8px;
    font-weight: 900;
    letter-spacing: 0.8px;
  }

  .training-progress b {
    margin-top: 4px;
    font-size: 11px;
  }

  .training-progress > i {
    display: block;
    flex: 1;
    height: 7px;
    overflow: hidden;
    border-radius: 10px;
    background: #dce6ed;
  }

  .training-progress > i em {
    display: block;
    height: 100%;
    border-radius: 10px;
    background:
      linear-gradient(
        90deg,
        var(--fin-blue),
        #2c91c8
      );
  }

  .training-list {
    overflow: hidden;
    border: 1px solid var(--fin-line);
    border-radius: 14px;
  }

  .training-list article + article {
    border-top: 1px solid var(--fin-line);
  }

  .training-list article > button {
    display: grid;
    grid-template-columns:
      auto 1fr auto;
    align-items: center;
    gap: 14px;
    width: 100%;
    padding: 16px;
    border: 0;
    background: #ffffff;
    text-align: left;
    cursor: pointer;
  }

  .training-list article.open > button {
    background: #f7fafc;
  }

  .lesson-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #e8f1f7;
    color: var(--fin-blue);
    font-size: 9px;
    font-weight: 900;
  }

  .training-list button > span:nth-child(2) {
    min-width: 0;
  }

  .training-list button b,
  .training-list button small {
    display: block;
  }

  .training-list button b {
    color: var(--fin-ink);
    font-size: 11px;
  }

  .training-list button small {
    margin-top: 4px;
    overflow: hidden;
    color: #82909f;
    font-size: 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .training-list button > em {
    color: #7890a3;
    font-size: 18px;
    font-style: normal;
  }

  .lesson-content {
    padding: 0 20px 20px 66px;
    background: #f7fafc;
  }

  .lesson-content p {
    margin: 0 0 12px;
    color: #607286;
    font-size: 10px;
    line-height: 1.65;
  }

  .lesson-content ol {
    margin: 0 0 13px;
    padding-left: 18px;
  }

  .lesson-content li {
    padding: 4px 0;
    color: #465b70;
    font-size: 9px;
  }

  .support-card {
    display: flex;
    gap: 14px;
    margin-top: 20px;
    padding: 18px;
    border-radius: 13px;
    background:
      linear-gradient(
        125deg,
        #082c4e,
        #0d568e
      );
    color: #ffffff;
  }

  .support-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    height: 40px;
    border:
      1px solid
      rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    background:
      rgba(255, 255, 255, 0.08);
    font-weight: 900;
  }

  .support-card b {
    font-size: 11px;
  }

  .support-card p {
    margin: 5px 0 0;
    color: #bad0e0;
    font-size: 9px;
    line-height: 1.6;
  }

  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 150px;
    padding: 25px;
    text-align: center;
  }

  .empty-state > span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 43px;
    height: 43px;
    margin-bottom: 9px;
    border-radius: 13px;
    background: #edf3f7;
    color: #7690a4;
    font-size: 19px;
  }

  .empty-state b {
    font-size: 11px;
  }

  .empty-state p {
    margin: 5px 0 0;
    color: #8997a5;
    font-size: 9px;
  }

  .finance-notice {
    position: fixed;
    z-index: 1000;
    top: 22px;
    right: 25px;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 12px 17px;
    border-radius: 11px;
    background: #153e5e;
    color: #ffffff;
    box-shadow:
      0 10px 28px
      rgba(9, 40, 66, 0.25);
    font-size: 10px;
    font-weight: 750;
  }

  .finance-notice span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #3ec58a;
  }

  .finance-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 8px;
    min-height: 60vh;
    color: #687b8e;
    font-family:
      Inter,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
  }

  .finance-loading b {
    color: var(--fin-navy);
    font-size: 15px;
  }

  .finance-loading > span {
    font-size: 10px;
  }

  .loading-mark {
    display: flex;
    align-items: flex-end;
    gap: 4px;
    height: 38px;
    margin-bottom: 7px;
  }

  .loading-mark i {
    width: 7px;
    border-radius: 4px;
    background: var(--fin-blue);
    animation:
      financeBars
      0.8s infinite alternate;
  }

  .loading-mark i:nth-child(1) {
    height: 17px;
  }

  .loading-mark i:nth-child(2) {
    height: 30px;
    animation-delay: 0.15s;
  }

  .loading-mark i:nth-child(3) {
    height: 23px;
    animation-delay: 0.3s;
  }

  .error-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #f9e7e7;
    color: var(--fin-red);
    font-size: 22px;
    font-weight: 900;
  }

  @keyframes financeBars {
    to {
      height: 11px;
      opacity: 0.5;
    }
  }

  @media (max-width: 1180px) {
    .finance-hero {
      align-items: flex-start;
      flex-direction: column;
    }

    .hero-actions {
      justify-content: flex-start;
      max-width: none;
    }

    .metrics-grid {
      grid-template-columns:
        repeat(2, 1fr);
    }

    .quick-grid {
      grid-template-columns:
        repeat(2, 1fr);
    }

    .transaction-grid {
      grid-template-columns:
        repeat(3, 1fr);
    }

    .payroll-layout,
    .company-layout {
      grid-template-columns: 1fr;
    }

    .company-preview-panel {
      position: static;
    }

    .employee-cards {
      grid-template-columns:
        repeat(2, 1fr);
    }

    .finance-filters {
      grid-template-columns:
        repeat(3, 1fr);
    }

    .filter-wide {
      grid-column: span 2;
    }
  }

  @media (max-width: 850px) {
    .finance-tabs {
      display: flex;
      padding: 0 14px;
      overflow-x: auto;
    }

    .finance-tabs button {
      flex: 0 0 auto;
      padding: 0 18px;
    }

    .context-bar {
      align-items: flex-start;
      flex-direction: column;
    }

    .overview-columns,
    .report-columns {
      grid-template-columns: 1fr;
    }

    .payroll-layout {
      grid-template-columns: 1fr;
    }

    .employee-cards {
      grid-template-columns: 1fr;
    }

    .transaction-grid {
      grid-template-columns:
        repeat(2, 1fr);
    }

    .finance-filters {
      display: none;
      grid-template-columns:
        repeat(2, 1fr);
    }

    .finance-filters.open {
      display: grid;
    }

    .mobile-filter-toggle {
      display: block;
    }

    .report-control .section-heading,
    .filters-panel .section-heading {
      align-items: flex-start;
    }

    .report-actions {
      flex-direction: column;
    }

    .metric-card strong {
      font-size: 22px;
    }
  }

  @media (max-width: 580px) {
    .finance-hero {
      padding: 28px 18px;
    }

    .hero-copy h1 {
      font-size: 27px;
    }

    .hero-btn {
      padding: 0 11px;
    }

    .hero-btn span {
      display: none;
    }

    .hero-status span + span::before {
      display: none;
    }

    .finance-main {
      padding: 15px 12px;
    }

    .panel {
      padding: 17px;
      border-radius: 14px;
    }

    .context-bar {
      padding: 14px 12px 0;
    }

    .period-pills {
      width: 100%;
      overflow-x: auto;
    }

    .period-pills button {
      flex: 0 0 auto;
    }

    .metrics-grid {
      grid-template-columns: 1fr;
    }

    .metric-card {
      min-height: 110px;
    }

    .quick-grid {
      grid-template-columns: 1fr;
    }

    .section-heading {
      flex-direction: column;
    }

    .section-action {
      width: 100%;
    }

    .section-action .btn {
      width: 100%;
    }

    .transaction-grid,
    .two-col,
    .finance-filters {
      grid-template-columns: 1fr;
    }

    .filter-wide,
    .span-2 {
      grid-column: span 1;
    }

    .form-summary {
      align-items: stretch;
      flex-direction: column;
    }

    .form-actions .btn {
      flex: 1;
    }

    .expense-row > strong {
      min-width: auto;
    }

    .expense-info > div {
      flex-direction: column;
    }

    .employee-card {
      grid-template-columns:
        auto 1fr;
    }

    .employee-actions {
      grid-column: 1 / 3;
    }

    .status-badge {
      right: 10px;
    }

    .training-progress {
      align-items: flex-start;
      flex-direction: column;
      gap: 10px;
    }

    .training-progress > i {
      width: 100%;
      flex: none;
    }

    .training-list article > button {
      gap: 10px;
      padding: 13px;
    }

    .training-list button small {
      display: none;
    }

    .lesson-content {
      padding: 0 14px 16px;
    }

    .paper-header {
      flex-direction: column;
    }

    .paper-brand {
      max-width: 100%;
    }

    .paper-tax {
      align-items: flex-start;
    }

    .finance-notice {
      top: 14px;
      right: 14px;
      left: 14px;
    }

    .logo-upload-row {
      align-items: flex-start;
    }

    .report-paper {
      min-height: 390px;
      padding: 15px;
    }
  }

  /* =========================================================
     KURUMSAL MOBİL DÜZEN
     İş mantığına dokunmaz; yalnızca 680px ve altını düzenler.
  ========================================================= */
  @media (max-width: 680px) {
    .finance-app {
      width: 100%;
      max-width: 100vw;
      overflow-x: hidden;
      padding-bottom: 28px;
    }

    .finance-app *,
    .finance-app *::before,
    .finance-app *::after {
      min-width: 0;
    }

    .finance-hero {
      width: 100%;
      padding: 22px 14px 18px;
      gap: 18px;
      overflow: hidden;
    }

    .finance-hero::before {
      top: -95px;
      right: -160px;
      width: 360px;
      height: 360px;
    }

    .hero-copy {
      width: 100%;
      max-width: 100%;
    }

    .hero-eyebrow {
      margin-bottom: 10px;
      font-size: 9px;
      line-height: 1.35;
      letter-spacing: 1.25px;
      white-space: normal;
    }

    .hero-copy h1 {
      width: 100%;
      max-width: 100%;
      margin-bottom: 8px;
      overflow: visible;
      font-size: clamp(24px, 7.3vw, 30px);
      line-height: 1.12;
      letter-spacing: -0.7px;
      white-space: normal !important;
      overflow-wrap: anywhere;
      word-break: normal;
    }

    .hero-copy > p {
      display: -webkit-box;
      max-width: 100%;
      overflow: hidden;
      color: #c8d9e7;
      font-size: 11px;
      line-height: 1.5;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }

    .hero-status {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 7px 12px;
      width: 100%;
      margin-top: 14px;
      font-size: 9px;
    }

    .hero-status span {
      min-height: 20px;
    }

    .hero-status span + span::before {
      display: none;
    }

    .hero-actions {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
      width: 100%;
      max-width: 100%;
    }

    .hero-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 42px;
      padding: 0 8px;
      border-radius: 9px;
      font-size: 11px;
      white-space: nowrap;
    }

    .hero-btn span {
      display: inline !important;
      overflow: hidden;
      font-size: 9px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .finance-tabs {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 6px;
      width: 100%;
      padding: 9px 10px;
      overflow: visible;
      border-bottom: 1px solid var(--fin-line);
      background: #ffffff;
    }

    .finance-tabs button {
      justify-content: flex-start;
      width: 100%;
      min-height: 45px;
      padding: 7px 10px;
      overflow: hidden;
      border: 1px solid #e4ebf1;
      border-radius: 9px;
      background: #f8fafc;
      font-size: 10px;
      line-height: 1.2;
      text-align: left;
      white-space: normal;
    }

    .finance-tabs button span {
      flex: 0 0 auto;
      margin: 0;
    }

    .finance-tabs button::after {
      display: none;
    }

    .finance-tabs button.active {
      border-color: #bcd2e4;
      background: #eaf3fa;
      box-shadow: inset 3px 0 0 var(--fin-orange);
    }

    .context-bar {
      width: 100%;
      padding: 12px 10px 0;
      gap: 10px;
    }

    .period-pills {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 4px;
      width: 100%;
      padding: 4px;
      overflow: visible;
    }

    .period-pills button {
      width: 100%;
      height: 32px;
      padding: 0 5px;
      font-size: 9px;
    }

    .currency-select {
      justify-content: space-between;
      width: 100%;
      padding: 0 2px;
    }

    .currency-select select {
      min-width: 118px;
    }

    .finance-main {
      width: 100%;
      gap: 12px;
      padding: 12px 10px 20px;
    }

    .panel {
      width: 100%;
      padding: 14px;
      overflow: hidden;
      border-radius: 13px;
      box-shadow: 0 6px 18px rgba(22, 47, 72, 0.06);
    }

    .section-heading {
      gap: 10px;
      margin-bottom: 15px;
    }

    .section-heading h2 {
      font-size: 16px;
      overflow-wrap: anywhere;
    }

    .section-heading p {
      font-size: 10px;
    }

    .section-action,
    .section-action > *,
    .report-actions {
      width: 100%;
    }

    .report-actions {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 7px;
    }

    .metrics-grid,
    .metrics-grid.report-metrics {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 9px;
    }

    .metric-card {
      display: grid;
      grid-template-columns: 34px minmax(0, 1fr);
      gap: 9px;
      min-height: 108px;
      padding: 13px 11px;
      border-radius: 12px;
    }

    .metric-icon {
      width: 34px;
      height: 34px;
      flex-basis: 34px;
      border-radius: 9px;
      font-size: 16px;
    }

    .metric-card small {
      min-height: 22px;
      margin-bottom: 4px;
      font-size: 7px;
      line-height: 1.35;
    }

    .metric-card strong {
      max-width: 100%;
      overflow: hidden;
      font-size: clamp(16px, 5vw, 21px);
      text-overflow: ellipsis;
    }

    .metric-card p {
      margin-top: 7px;
      font-size: 8px;
    }

    .quick-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .quick-grid button {
      gap: 8px;
      min-height: 68px;
      padding: 10px 8px;
      border-radius: 11px;
    }

    .quick-icon {
      flex-basis: 34px;
      height: 34px;
      border-radius: 9px;
      font-size: 9px;
    }

    .quick-grid button b {
      font-size: 10px;
    }

    .quick-grid button small,
    .quick-grid button em {
      display: none;
    }

    .overview-columns,
    .report-columns,
    .payroll-layout,
    .company-layout,
    .transaction-grid,
    .two-col,
    .finance-filters,
    .employee-cards {
      grid-template-columns: 1fr;
    }

    .finance-filters {
      gap: 9px;
      padding: 11px;
    }

    .field input,
    .field select {
      height: 44px;
      font-size: 16px;
    }

    .field textarea {
      font-size: 16px;
    }

    .form-actions,
    .form-actions.end {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      width: 100%;
    }

    .form-actions .btn {
      width: 100%;
      padding: 0 9px;
    }

    .employee-card {
      padding: 13px;
    }

    .employee-actions {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      width: 100%;
    }

    .employee-actions button {
      min-height: 34px;
    }

    /* Masaüstü tabloyu mobilde kurumsal kayıt kartlarına dönüştürür. */
    .table-scroll {
      width: 100%;
      overflow: visible;
    }

    .finance-table,
    .finance-table tbody,
    .finance-table tr,
    .finance-table td {
      display: block;
      width: 100%;
    }

    .finance-table {
      min-width: 0;
      border-collapse: separate;
    }

    .finance-table thead {
      display: none;
    }

    .finance-table tbody {
      display: grid;
      gap: 10px;
    }

    .finance-table tbody tr {
      overflow: hidden;
      border: 1px solid #dfe8ef;
      border-left: 3px solid var(--fin-blue);
      border-radius: 12px;
      background: #ffffff;
      box-shadow: 0 4px 14px rgba(20, 51, 77, 0.05);
    }

    .finance-table tbody tr:hover {
      background: #ffffff;
    }

    .finance-table td,
    .finance-table tbody tr:last-child td {
      display: grid;
      grid-template-columns: 82px minmax(0, 1fr);
      align-items: center;
      gap: 10px;
      min-height: 39px;
      padding: 8px 10px;
      border-bottom: 1px solid #edf2f6;
      font-size: 10px;
      text-align: left !important;
      white-space: normal;
    }

    .finance-table td:last-child {
      border-bottom: 0;
    }

    .finance-table td::before {
      color: #8191a1;
      font-size: 7px;
      font-weight: 900;
      letter-spacing: 0.55px;
      text-transform: uppercase;
    }

    .finance-table td:nth-child(1)::before { content: "Tarih"; }
    .finance-table td:nth-child(2)::before { content: "İşlem"; }
    .finance-table td:nth-child(3)::before { content: "Kaynak"; }
    .finance-table td:nth-child(4)::before { content: "İlgili"; }
    .finance-table td:nth-child(5)::before { content: "Ödeme"; }
    .finance-table td:nth-child(6)::before { content: "Tutar"; }
    .finance-table td:nth-child(7)::before { content: "Aksiyon"; }

    .transaction-name {
      width: 100%;
      min-width: 0;
    }

    .transaction-name b {
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;
    }

    .amount-cell {
      font-size: 12px !important;
      text-align: left !important;
    }

    .row-actions {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 7px;
      width: 100%;
    }

    .row-actions button {
      min-height: 34px;
      padding: 0 8px;
      font-size: 9px;
    }

    .expense-row {
      align-items: flex-start;
      gap: 9px;
    }

    .expense-row > strong {
      max-width: 92px;
      font-size: 9px;
      overflow-wrap: anywhere;
    }

    .logo-upload-row,
    .support-card,
    .draft-banner {
      align-items: flex-start;
    }

    .logo-upload-row {
      flex-wrap: wrap;
    }

    .company-logo-preview {
      flex-basis: 62px;
      height: 62px;
    }

    .report-paper {
      width: 100%;
      min-height: 330px;
      padding: 12px;
      overflow: hidden;
    }

    .finance-notice {
      top: 12px;
      right: 10px;
      left: 10px;
      max-width: calc(100vw - 20px);
    }
  }

  @media (max-width: 360px) {
    .metrics-grid,
    .metrics-grid.report-metrics {
      grid-template-columns: 1fr;
    }

    .hero-actions,
    .quick-grid,
    .report-actions,
    .form-actions,
    .form-actions.end {
      grid-template-columns: 1fr;
    }

    .finance-table td {
      grid-template-columns: 70px minmax(0, 1fr);
    }
  }
`;
